export default {
    zh: {
        // SEO Meta
        pageTitle: 'Kling O1 AI 视频生成器 - 统一多模态视频模型、自然语言编辑、角色一致性',
        pageDescription: '体验快手可灵 AI 最新力作 Kling O1，行业首个统一多模态视频模型，支持自然语言视频编辑、首尾帧控制和多主体一致性生成。在 WeryAI 立即体验。',
        pageKeywords: 'Kling O1, 可灵 O1, 统一多模态, 视频编辑, 角色一致性, AI视频生成器, 自然语言编辑, WeryAI',

        // 生成器部分
        generatorTitle: 'Kling O1 视频生成器',
        generatorDescription: 'WeryAI 现已深度集成Kling O1模型，Kling O1 是快手可灵 AI（Kling AI）于 2025 年 12 月重磅推出的行业首个统一多模态视频模型（Unified Multimodal Video Model）。与传统的文生视频模型不同，Kling O1 采用革命性的 MVL（多模态视觉语言）架构，打破了视频生成与编辑的界限，允许用户通过自然语言对话直接修改现有视频中的元素、光影或动作，而无需复杂的遮罩或后期软件。它不仅能生成高质量视频，更解决了 AI 视频"角色一致性"和"精准编辑"的两大痛点，是创作者实现从灵感到成片的一站式神器。快来 WeryAI 免费体验 Kling O1，用一句话重新定义您的视频后期工作流！',

        // 标签页
        tabImageToVideo: '图片生成视频',
        tabTextToVideo: '文本生成视频',

        // 核心功能部分
        coreFeaturesTitle: 'Kling O1 核心功能特性',

        // 功能特点
        feature1Title: '自然语言视频编辑（Video Inpainting & Editing）',
        feature1Description: '这是 Kling O1 最具革命性的功能。您无需使用专业的视频剪辑软件进行逐帧遮罩（Rotoscoping），只需输入简单的文字指令，模型就能理解视频内容，精准地移除物体、替换背景或改变特定元素的颜色，同时完美保留视频原有的运动轨迹和光影关系。',
        feature2Title: '首尾帧一致性控制（Start & End Frame Control）',
        feature2Description: '允许用户同时上传一张起始图像和一张结束图像，Kling O1 会自动生成这两帧之间自然、流畅的过渡动画。这对于制作丝滑的场景转换、物体变形或连接两个不同的镜头至关重要，极大地提升了叙事的连贯性。',
        feature3Title: '多主体一致性生成（Multi-Subject Consistency）',
        feature3Description: '解决了 AI 视频中"换个镜头人就变了"的难题。Kling O1 拥有类似"导演记忆"的能力，能够理解并记住用户上传的角色或物体特征（如面部、服装、道具），在不同的镜头和运镜下保持高度一致的外观，非常适合制作连续的短剧或广告。',
        feature4Title: '视频风格迁移与重绘（Video Style Repainting）',
        feature4Description: '在保持原视频结构、构图和动作完全不变的前提下，通过文字提示将视频整体渲染为全新的艺术风格。无论是将实拍视频转为二次元动漫，还是将白天场景改为赛博朋克夜景，都能一键实现。',
        feature5Title: '运动轨迹复刻（Motion Transfer）',
        feature5Description: '提取一个参考视频中的运动模式（如运镜方式或人物动作），并将其应用到全新的主体或场景中。这意味着你可以用一段简单的手机实拍作为"动作捕捉"素材，让 AI 生成的高质量角色做出完全相同的动作。',

        // 如何使用部分
        howToUseTitle: '如何在 WeryAI 上使用 Kling O1',
        step1Title: '选择模型',
        step1Description: '在 AI 视频工具中选择 Kling O1 模型',
        step2Title: '选择功能',
        step2Description: '选择首尾帧生视频或多图参考生视频',
        step3Title: '输入内容',
        step3Description: '上传参考图像并输入提示词',
        step4Title: '生成视频',
        step4Description: '点击生成按钮，等待并下载您的视频',

        // YouTube 视频部分
        youtubeTitle: '关于 Kling O1 的精彩视频介绍',

        // X Posts 部分
        xPostsTitle: '探索关于 Kling O1 的更多讨论',

        // 探索其他模型部分
        exploreModelsTitle: '探索 WeryAI 上的其他视频模型',
        kling25Title: 'Kling 2.5 Turbo Pro',
        runwayTitle: 'Runway Gen-4.5',
        lumaTitle: 'Luma 梦想机器',

        // FAQ 部分
        faqTitle: '常见问题',

        // CTA 部分
        ctaTitle: '立即体验 Kling O1',
        ctaDescription: '在 WeryAI 上免费开始创作统一多模态的 AI 视频',
        ctaButton: '开始生成视频',
        ctaDisclaimer: '无需信用卡，注册即可使用',

        // YouTube 视频标题
        youtubeVideo1Title: 'Kling O1 - 官方演示',
        youtubeVideo2Title: 'Kling O1 - 功能概览',
        youtubeVideo3Title: 'Kling O1 - 教程',
        youtubeVideo4Title: 'Kling O1 - 高级技巧',
        youtubeVideo5Title: 'Kling O1 - 创意工作流',
        youtubeVideo6Title: 'Kling O1 - 最佳实践',

        // Alt 文本
        logoAlt: 'Kling',

        // Structured Data
        structuredDataName: 'Kling O1 AI 视频生成器',
        structuredDataDescription: 'Kling O1 是行业首个统一多模态视频模型，支持自然语言视频编辑、首尾帧控制和多主体一致性',
        structuredDataFeature1: '自然语言视频编辑',
        structuredDataFeature2: '首尾帧控制',
        structuredDataFeature3: '多主体一致性',
        structuredDataFeature4: '视频风格重绘',
        structuredDataFeature5: '运动轨迹复刻',
    },
    en: {
        // SEO Meta
        pageTitle: 'Kling O1 AI Video Generator - Unified Multimodal Video Model, Natural Language Editing, Character Consistency',
        pageDescription: 'Experience Kuaishou Kling AI\'s latest masterpiece Kling O1, the industry\'s first unified multimodal video model supporting natural language video editing, start & end frame control, and multi-subject consistency. Try now on WeryAI.',
        pageKeywords: 'Kling O1, unified multimodal, video editing, character consistency, AI video generator, natural language editing, WeryAI',

        // Generator section
        generatorTitle: 'Kling O1 Video Generator',
        generatorDescription: 'WeryAI now deeply integrates the Kling O1 model, Kling O1 is the industry\'s first unified multimodal video model launched by Kuaishou Kling AI in December 2025. Unlike traditional text-to-video models, Kling O1 adopts a revolutionary MVL (Multimodal Visual Language) architecture, breaking the boundaries between video generation and editing, allowing users to directly modify elements, lighting, or actions in existing videos through natural language conversation, without complex masks or post-production software. It not only generates high-quality videos but also solves the two major pain points of AI video: "character consistency" and "precise editing". Experience Kling O1 on WeryAI for free and redefine your video post-production workflow with a single sentence!',

        // Tabs
        tabImageToVideo: 'Image to Video',
        tabTextToVideo: 'Text to Video',

        // Core features section
        coreFeaturesTitle: 'Kling O1 Core Features',

        // Features
        feature1Title: 'Natural Language Video Editing (Video Inpainting & Editing)',
        feature1Description: 'This is Kling O1\'s most revolutionary feature. You don\'t need to use professional video editing software for frame-by-frame rotoscoping. Simply input text instructions, and the model can understand video content, precisely remove objects, replace backgrounds, or change the color of specific elements while perfectly preserving the video\'s original motion trajectories and lighting relationships.',
        feature2Title: 'Start & End Frame Control',
        feature2Description: 'Allows users to upload both a start image and an end image, and Kling O1 will automatically generate natural, smooth transition animations between these two frames. This is crucial for creating seamless scene transitions, object morphing, or connecting two different shots, greatly enhancing narrative coherence.',
        feature3Title: 'Multi-Subject Consistency',
        feature3Description: 'Solves the problem of "characters changing between shots" in AI videos. Kling O1 has a "director\'s memory" capability, understanding and remembering character or object features (such as faces, clothing, props) uploaded by users, maintaining highly consistent appearance across different shots and camera movements. Perfect for creating continuous short dramas or advertisements.',
        feature4Title: 'Video Style Repainting',
        feature4Description: 'While keeping the original video\'s structure, composition, and motion completely unchanged, render the entire video into a new artistic style through text prompts. Whether converting live-action footage to anime, or changing daytime scenes to cyberpunk nightscapes, it can be done with one click.',
        feature5Title: 'Motion Transfer',
        feature5Description: 'Extract motion patterns (such as camera movements or character actions) from a reference video and apply them to entirely new subjects or scenes. This means you can use a simple phone recording as "motion capture" material and have AI-generated high-quality characters perform exactly the same movements.',

        // How to use section
        howToUseTitle: 'How to Use Kling O1 on WeryAI',
        step1Title: 'Select Model',
        step1Description: 'Select the Kling O1 model in the AI video tool.',
        step2Title: 'Select Function',
        step2Description: 'Choose Start/End Frame Generation or Multi-Image Reference Generation.',
        step3Title: 'Input Content',
        step3Description: 'Upload reference images and enter prompts.',
        step4Title: 'Generate Video',
        step4Description: 'Click the Generate button, wait, and download your video.',

        // YouTube videos section
        youtubeTitle: 'Exciting Video Introductions About Kling O1',

        // X Posts section
        xPostsTitle: 'Explore More Discussions About Kling O1',

        // Explore other models section
        exploreModelsTitle: 'Explore Other Video Models on WeryAI',
        kling25Title: 'Kling 2.5 Turbo Pro',
        runwayTitle: 'Runway Gen-4.5',
        lumaTitle: 'Luma Dream Machine',

        // FAQ section
        faqTitle: 'Frequently Asked Questions',

        // CTA section
        ctaTitle: 'Experience Kling O1 Now',
        ctaDescription: 'Start creating unified multimodal AI videos for free on WeryAI',
        ctaButton: 'Start Generating Videos',
        ctaDisclaimer: 'No credit card required, register to use',

        // YouTube video titles
        youtubeVideo1Title: 'Kling O1 - Official Demo',
        youtubeVideo2Title: 'Kling O1 - Features Overview',
        youtubeVideo3Title: 'Kling O1 - Tutorial',
        youtubeVideo4Title: 'Kling O1 - Advanced Techniques',
        youtubeVideo5Title: 'Kling O1 - Creative Workflow',
        youtubeVideo6Title: 'Kling O1 - Best Practices',

        // Alt text
        logoAlt: 'Kling',

        // Structured Data
        structuredDataName: 'Kling O1 AI Video Generator',
        structuredDataDescription: 'Kling O1 is the industry\'s first unified multimodal video model supporting natural language video editing, start & end frame control, and multi-subject consistency',
        structuredDataFeature1: 'Natural Language Video Editing',
        structuredDataFeature2: 'Start & End Frame Control',
        structuredDataFeature3: 'Multi-Subject Consistency',
        structuredDataFeature4: 'Video Style Repainting',
        structuredDataFeature5: 'Motion Transfer',
    },
    ja: {
        // SEO Meta
        pageTitle: 'Kling O1 AI動画ジェネレーター - 統一マルチモーダル動画モデル、自然言語編集、キャラクター一貫性',
        pageDescription: '快手可霊AIの最新作Kling O1を体験。業界初の統一マルチモーダル動画モデルで、自然言語動画編集、開始・終了フレーム制御、マルチサブジェクト一貫性をサポート。WeryAIで今すぐ体験。',
        pageKeywords: 'Kling O1, 統一マルチモーダル, 動画編集, キャラクター一貫性, AI動画ジェネレーター, 自然言語編集, WeryAI',

        // Generator section
        generatorTitle: 'Kling O1 動画ジェネレーター',
        generatorDescription: 'WeryAI はKling O1モデルを深く統合し、Kling O1は、2025年12月に快手可霊AI（Kling AI）が発表した業界初の統一マルチモーダル動画モデル（Unified Multimodal Video Model）です。従来のテキストから動画を生成するモデルとは異なり、Kling O1は革新的なMVL（マルチモーダル視覚言語）アーキテクチャを採用し、動画生成と編集の境界を打破し、複雑なマスクや後処理ソフトウェアなしで、自然言語会話を通じて既存の動画の要素、照明、またはアクションを直接変更することを可能にします。高品質な動画を生成するだけでなく、AI動画の「キャラクター一貫性」と「精密編集」という2つの主要な課題を解決します。WeryAIでKling O1を無料で体験し、一文で動画後処理ワークフローを再定義しましょう！',

        // Tabs
        tabImageToVideo: '画像から動画',
        tabTextToVideo: 'テキストから動画',

        // Core features section
        coreFeaturesTitle: 'Kling O1 コア機能',

        // Features
        feature1Title: '自然言語動画編集（Video Inpainting & Editing）',
        feature1Description: 'これはKling O1の最も革新的な機能です。フレームごとのロトスコープ（Rotoscoping）のためにプロフェッショナルな動画編集ソフトウェアを使用する必要はありません。簡単なテキスト指示を入力するだけで、モデルは動画コンテンツを理解し、動画の元の動きの軌跡と照明の関係を完璧に保持しながら、オブジェクトを正確に削除し、背景を置き換え、または特定の要素の色を変更できます。',
        feature2Title: '開始・終了フレーム制御（Start & End Frame Control）',
        feature2Description: 'ユーザーが開始画像と終了画像の両方をアップロードできるようにし、Kling O1はこれらの2つのフレーム間の自然で滑らかな遷移アニメーションを自動生成します。これは、シームレスなシーン遷移、オブジェクトの変形、または2つの異なるショットを接続するために重要であり、物語の一貫性を大幅に向上させます。',
        feature3Title: 'マルチサブジェクト一貫性（Multi-Subject Consistency）',
        feature3Description: 'AI動画における「ショット間でキャラクターが変わる」という問題を解決します。Kling O1は「監督の記憶」のような能力を持ち、ユーザーがアップロードしたキャラクターまたはオブジェクトの特徴（顔、服装、小道具など）を理解し、記憶し、異なるショットとカメラの動きにわたって高度に一貫した外観を維持します。連続した短編ドラマや広告の作成に最適です。',
        feature4Title: '動画スタイル再描画（Video Style Repainting）',
        feature4Description: '元の動画の構造、構図、動きを完全に変更せずに、テキストプロンプトを通じて動画全体を新しい芸術スタイルにレンダリングします。実写動画をアニメに変換する場合でも、昼間のシーンをサイバーパンクの夜景に変更する場合でも、ワンクリックで実現できます。',
        feature5Title: '動きの転送（Motion Transfer）',
        feature5Description: '参照動画から動きのパターン（カメラの動きやキャラクターのアクションなど）を抽出し、まったく新しい被写体やシーンに適用します。これは、簡単な電話録画を「モーションキャプチャ」素材として使用し、AI生成の高品質キャラクターにまったく同じ動きを実行させることができることを意味します。',

        // How to use section
        howToUseTitle: 'WeryAIでKling O1を使用する方法',
        step1Title: 'モデルを選択',
        step1Description: 'AI動画ツールでKling O1モデルを選択します。',
        step2Title: '機能を選択',
        step2Description: '開始・終了フレーム生成または複数画像参照生成を選択します。',
        step3Title: 'コンテンツを入力',
        step3Description: '参照画像をアップロードし、プロンプトを入力します。',
        step4Title: '動画を生成',
        step4Description: '生成ボタンをクリックし、待機して動画をダウンロードします。',

        // YouTube videos section
        youtubeTitle: 'Kling O1に関する素晴らしい動画紹介',
        youtubeVideo1Title: 'Kling O1 - 公式デモ',
        youtubeVideo2Title: 'Kling O1 - 機能概要',
        youtubeVideo3Title: 'Kling O1 - チュートリアル',
        youtubeVideo4Title: 'Kling O1 - 高度なテクニック',
        youtubeVideo5Title: 'Kling O1 - クリエイティブワークフロー',
        youtubeVideo6Title: 'Kling O1 - ベストプラクティス',

        // X Posts section
        xPostsTitle: 'Kling O1に関するさらなる議論を探索',

        // Explore other models section
        exploreModelsTitle: 'WeryAI上の他の動画モデルを探索',
        kling25Title: 'Kling 2.5 Turbo Pro',
        runwayTitle: 'Runway Gen-4.5',
        lumaTitle: 'Luma Dream Machine',

        // FAQ section
        faqTitle: 'よくある質問',

        // CTA section
        ctaTitle: '今すぐKling O1を体験',
        ctaDescription: 'WeryAIで統一マルチモーダルAI動画の作成を無料で開始',
        ctaButton: '動画生成を開始',
        ctaDisclaimer: 'クレジットカード不要、登録して使用',

        // Alt text
        logoAlt: 'Kling',

        // Structured Data
        structuredDataName: 'Kling O1 AI動画ジェネレーター',
        structuredDataDescription: 'Kling O1は、自然言語動画編集、開始・終了フレーム制御、マルチサブジェクト一貫性をサポートする業界初の統一マルチモーダル動画モデルです',
        structuredDataFeature1: '自然言語動画編集',
        structuredDataFeature2: '開始・終了フレーム制御',
        structuredDataFeature3: 'マルチサブジェクト一貫性',
        structuredDataFeature4: '動画スタイル再描画',
        structuredDataFeature5: '動きの転送',
    },
    ko: {
        // SEO Meta
        pageTitle: 'Kling O1 AI 비디오 생성기 - 통합 멀티모달 비디오 모델, 자연어 편집, 캐릭터 일관성',
        pageDescription: '快手可霊AI의 최신작 Kling O1을 체험하세요. 업계 최초의 통합 멀티모달 비디오 모델로, 자연어 비디오 편집, 시작 및 종료 프레임 제어, 다중 주제 일관성을 지원합니다. WeryAI에서 지금 바로 체험하세요.',
        pageKeywords: 'Kling O1, 통합 멀티모달, 비디오 편집, 캐릭터 일관성, AI 비디오 생성기, 자연어 편집, WeryAI',

        // Generator section
        generatorTitle: 'Kling O1 비디오 생성기',
        generatorDescription: 'WeryAI는 이제 Kling O1 모델을 심층 통합하여, Kling O1은 2025년 12월에 快手可霊AI(Kling AI)가 발표한 업계 최초의 통합 멀티모달 비디오 모델(Unified Multimodal Video Model)입니다. 기존의 텍스트에서 비디오를 생성하는 모델과 달리, Kling O1은 혁신적인 MVL(멀티모달 시각 언어) 아키텍처를 채택하여 비디오 생성과 편집의 경계를 깨뜨리고, 복잡한 마스크나 후처리 소프트웨어 없이 자연어 대화를 통해 기존 비디오의 요소, 조명 또는 동작을 직접 수정할 수 있게 합니다. 고품질 비디오를 생성할 뿐만 아니라 AI 비디오의 "캐릭터 일관성"과 "정밀 편집"이라는 두 가지 주요 문제를 해결합니다. WeryAI에서 Kling O1을 무료로 체험하고 한 문장으로 비디오 후처리 워크플로우를 재정의하세요!',

        // Tabs
        tabImageToVideo: '이미지에서 비디오',
        tabTextToVideo: '텍스트에서 비디오',

        // Core features section
        coreFeaturesTitle: 'Kling O1 핵심 기능',

        // Features
        feature1Title: '자연어 비디오 편집(Video Inpainting & Editing)',
        feature1Description: '이것은 Kling O1의 가장 혁신적인 기능입니다. 프레임별 로토스코핑(Rotoscoping)을 위해 전문 비디오 편집 소프트웨어를 사용할 필요가 없습니다. 간단한 텍스트 지시를 입력하기만 하면 모델은 비디오 콘텐츠를 이해하고, 비디오의 원래 움직임 궤적과 조명 관계를 완벽하게 유지하면서 객체를 정확하게 제거하고, 배경을 교체하거나 특정 요소의 색상을 변경할 수 있습니다.',
        feature2Title: '시작 및 종료 프레임 제어(Start & End Frame Control)',
        feature2Description: '사용자가 시작 이미지와 종료 이미지를 모두 업로드할 수 있도록 하며, Kling O1은 이 두 프레임 사이의 자연스럽고 부드러운 전환 애니메이션을 자동으로 생성합니다. 이는 매끄러운 장면 전환, 객체 변형 또는 두 개의 다른 샷을 연결하는 데 중요하며, 내러티브의 일관성을 크게 향상시킵니다。',
        feature3Title: '다중 주제 일관성(Multi-Subject Consistency)',
        feature3Description: 'AI 비디오에서 "샷 간에 캐릭터가 변하는" 문제를 해결합니다. Kling O1은 "감독의 기억"과 같은 능력을 가지고 있어, 사용자가 업로드한 캐릭터 또는 객체의 특징(얼굴, 의상, 소품 등)을 이해하고 기억하며, 다른 샷과 카메라 움직임에 걸쳐 높은 일관성을 유지합니다. 연속된 단편 드라마나 광고 제작에 완벽합니다.',
        feature4Title: '비디오 스타일 재그리기(Video Style Repainting)',
        feature4Description: '원본 비디오의 구조, 구도, 동작을 완전히 변경하지 않고 텍스트 프롬프트를 통해 비디오 전체를 새로운 예술 스타일로 렌더링합니다. 실사 비디오를 애니메이션으로 변환하거나, 낮 장면을 사이버펑크 야경으로 변경하는 경우에도 원클릭으로 구현할 수 있습니다.',
        feature5Title: '동작 전송(Motion Transfer)',
        feature5Description: '참조 비디오에서 동작 패턴(카메라 움직임 또는 캐릭터 동작 등)을 추출하여 완전히 새로운 피사체나 장면에 적용합니다. 이는 간단한 전화 녹화를 "모션 캡처" 자료로 사용하여 AI 생성 고품질 캐릭터가 정확히 동일한 동작을 수행하도록 할 수 있음을 의미합니다.',

        // How to use section
        howToUseTitle: 'WeryAI에서 Kling O1 사용 방법',
        step1Title: '모델 선택',
        step1Description: 'AI 비디오 도구에서 Kling O1 모델을 선택합니다.',
        step2Title: '기능 선택',
        step2Description: '시작/종료 프레임 생성 또는 다중 이미지 참조 생성을 선택합니다.',
        step3Title: '콘텐츠 입력',
        step3Description: '참조 이미지를 업로드하고 프롬프트를 입력합니다.',
        step4Title: '비디오 생성',
        step4Description: '생성 버튼을 클릭하고 기다린 후 비디오를 다운로드하십시오.',

        // YouTube videos section
        youtubeTitle: 'Kling O1에 대한 흥미진진한 비디오 소개',
        youtubeVideo1Title: 'Kling O1 - 공식 데모',
        youtubeVideo2Title: 'Kling O1 - 기능 개요',
        youtubeVideo3Title: 'Kling O1 - 튜토리얼',
        youtubeVideo4Title: 'Kling O1 - 고급 기법',
        youtubeVideo5Title: 'Kling O1 - 크리에이티브 워크플로우',
        youtubeVideo6Title: 'Kling O1 - 모범 사례',

        // X Posts section
        xPostsTitle: 'Kling O1에 대한 더 많은 토론 탐색',

        // Explore other models section
        exploreModelsTitle: 'WeryAI의 다른 비디오 모델 탐색',
        kling25Title: 'Kling 2.5 Turbo Pro',
        runwayTitle: 'Runway Gen-4.5',
        lumaTitle: 'Luma Dream Machine',

        // FAQ section
        faqTitle: '자주 묻는 질문',

        // CTA section
        ctaTitle: '지금 Kling O1 체험하기',
        ctaDescription: 'WeryAI에서 통합 멀티모달 AI 비디오 제작을 무료로 시작',
        ctaButton: '비디오 생성 시작',
        ctaDisclaimer: '신용카드 불필요, 등록하여 사용',

        // Alt text
        logoAlt: 'Kling',

        // Structured Data
        structuredDataName: 'Kling O1 AI 비디오 생성기',
        structuredDataDescription: 'Kling O1은 자연어 비디오 편집, 시작 및 종료 프레임 제어, 다중 주제 일관성을 지원하는 업계 최초의 통합 멀티모달 비디오 모델입니다',
        structuredDataFeature1: '자연어 비디오 편집',
        structuredDataFeature2: '시작 및 종료 프레임 제어',
        structuredDataFeature3: '다중 주제 일관성',
        structuredDataFeature4: '비디오 스타일 재그리기',
        structuredDataFeature5: '동작 전송',
    },
    tw: {

        // SEO Meta
        pageTitle: 'Kling O1 AI 视频生成器 - 统一多模态视频模型、自然语言编辑、角色一致性',
        pageDescription: '体验快手可灵 AI 最新力作 Kling O1，行业首个统一多模态视频模型，支持自然语言视频编辑、首尾帧控制和多主体一致性生成。在 WeryAI 立即体验。',
        pageKeywords: 'Kling O1, 可灵 O1, 统一多模态, 视频编辑, 角色一致性, AI视频生成器, 自然语言编辑, WeryAI',

        // 生成器部分
        generatorTitle: 'Kling O1 视频生成器',
        generatorDescription: 'WeryAI 現已深度整合Kling O1模型，Kling O1 是快手可灵 AI（Kling AI）于 2025 年 12 月重磅推出的行业首个统一多模态视频模型（Unified Multimodal Video Model）。与传统的文生视频模型不同，Kling O1 采用革命性的 MVL（多模态视觉语言）架构，打破了视频生成与编辑的界限，允许用户通过自然语言对话直接修改现有视频中的元素、光影或动作，而无需复杂的遮罩或后期软件。它不仅能生成高质量视频，更解决了 AI 视频"角色一致性"和"精准编辑"的两大痛点，是创作者实现从灵感到成片的一站式神器。快来 WeryAI 免费体验 Kling O1，用一句话重新定义您的视频后期工作流！',

        // 标签页
        tabImageToVideo: '图片生成视频',
        tabTextToVideo: '文本生成视频',

        // 核心功能部分
        coreFeaturesTitle: 'Kling O1 核心功能特性',

        // 功能特点
        feature1Title: '自然语言视频编辑（Video Inpainting & Editing）',
        feature1Description: '这是 Kling O1 最具革命性的功能。您无需使用专业的视频剪辑软件进行逐帧遮罩（Rotoscoping），只需输入简单的文字指令，模型就能理解视频内容，精准地移除物体、替换背景或改变特定元素的颜色，同时完美保留视频原有的运动轨迹和光影关系。',
        feature2Title: '首尾帧一致性控制（Start & End Frame Control）',
        feature2Description: '允许用户同时上传一张起始图像和一张结束图像，Kling O1 会自动生成这两帧之间自然、流畅的过渡动画。这对于制作丝滑的场景转换、物体变形或连接两个不同的镜头至关重要，极大地提升了叙事的连贯性。',
        feature3Title: '多主体一致性生成（Multi-Subject Consistency）',
        feature3Description: '解决了 AI 视频中"换个镜头人就变了"的难题。Kling O1 拥有类似"导演记忆"的能力，能够理解并记住用户上传的角色或物体特征（如面部、服装、道具），在不同的镜头和运镜下保持高度一致的外观，非常适合制作连续的短剧或广告。',
        feature4Title: '视频风格迁移与重绘（Video Style Repainting）',
        feature4Description: '在保持原视频结构、构图和动作完全不变的前提下，通过文字提示将视频整体渲染为全新的艺术风格。无论是将实拍视频转为二次元动漫，还是将白天场景改为赛博朋克夜景，都能一键实现。',
        feature5Title: '运动轨迹复刻（Motion Transfer）',
        feature5Description: '提取一个参考视频中的运动模式（如运镜方式或人物动作），并将其应用到全新的主体或场景中。这意味着你可以用一段简单的手机实拍作为"动作捕捉"素材，让 AI 生成的高质量角色做出完全相同的动作。',

        // 如何使用部分
        howToUseTitle: '如何在 WeryAI 上使用 Kling O1',
        step1Title: '选择模型',
        step1Description: '在 AI 视频工具中选择 Kling O1 模型',
        step2Title: '选择功能',
        step2Description: '选择首尾帧生视频或多图参考生视频',
        step3Title: '输入内容',
        step3Description: '上传参考图像并输入提示词',
        step4Title: '生成视频',
        step4Description: '点击生成按钮，等待并下载您的视频',

        // YouTube 视频部分
        youtubeTitle: '关于 Kling O1 的精彩视频介绍',

        // X Posts 部分
        xPostsTitle: '探索关于 Kling O1 的更多讨论',

        // 探索其他模型部分
        exploreModelsTitle: '探索 WeryAI 上的其他视频模型',
        kling25Title: 'Kling 2.5 Turbo Pro',
        runwayTitle: 'Runway Gen-4.5',
        lumaTitle: 'Luma 夢想機器',

        // FAQ 部分
        faqTitle: '常见问题',

        // CTA 部分
        ctaTitle: '立即体验 Kling O1',
        ctaDescription: '在 WeryAI 上免费开始创作统一多模态的 AI 视频',
        ctaButton: '开始生成视频',
        ctaDisclaimer: '无需信用卡，注册即可使用',

        // YouTube 视频标题
        youtubeVideo1Title: 'Kling O1 - 官方演示',
        youtubeVideo2Title: 'Kling O1 - 功能概览',
        youtubeVideo3Title: 'Kling O1 - 教程',
        youtubeVideo4Title: 'Kling O1 - 高级技巧',
        youtubeVideo5Title: 'Kling O1 - 创意工作流',
        youtubeVideo6Title: 'Kling O1 - 最佳实践',

        // Alt 文本
        logoAlt: 'Kling',

        // Structured Data
        structuredDataName: 'Kling O1 AI 视频生成器',
        structuredDataDescription: 'Kling O1 是行业首个统一多模态视频模型，支持自然语言视频编辑、首尾帧控制和多主体一致性',
        structuredDataFeature1: '自然语言视频编辑',
        structuredDataFeature2: '首尾帧控制',
        structuredDataFeature3: '多主体一致性',
        structuredDataFeature4: '视频风格重绘',
        structuredDataFeature5: '运动轨迹复刻',
    },
    pl: {

        // SEO Meta
        pageTitle: 'Kling O1 AI Video Generator - Unified Multimodal Video Model, Natural Language Editing, Character Consistency',
        pageDescription: 'Experience Kuaishou Kling AI\'s latest masterpiece Kling O1, the industry\'s first unified multimodal video model supporting natural language video editing, start & end frame control, and multi-subject consistency. Try now on WeryAI.',
        pageKeywords: 'Kling O1, unified multimodal, video editing, character consistency, AI video generator, natural language editing, WeryAI',

        // Generator section
        generatorTitle: 'Kling O1 Video Generator',
        generatorDescription: 'WeryAI jest teraz głęboko zintegrowane z modelem Kling O1, Kling O1 is the industry\'s first unified multimodal video model launched by Kuaishou Kling AI in December 2025. Unlike traditional text-to-video models, Kling O1 adopts a revolutionary MVL (Multimodal Visual Language) architecture, breaking the boundaries between video generation and editing, allowing users to directly modify elements, lighting, or actions in existing videos through natural language conversation, without complex masks or post-production software. It not only generates high-quality videos but also solves the two major pain points of AI video: "character consistency" and "precise editing". Experience Kling O1 on WeryAI for free and redefine your video post-production workflow with a single sentence!',

        // Tabs
        tabImageToVideo: 'Image to Video',
        tabTextToVideo: 'Text to Video',

        // Core features section
        coreFeaturesTitle: 'Kling O1 Core Features',

        // Features
        feature1Title: 'Natural Language Video Editing (Video Inpainting & Editing)',
        feature1Description: 'This is Kling O1\'s most revolutionary feature. You don\'t need to use professional video editing software for frame-by-frame rotoscoping. Simply input text instructions, and the model can understand video content, precisely remove objects, replace backgrounds, or change the color of specific elements while perfectly preserving the video\'s original motion trajectories and lighting relationships.',
        feature2Title: 'Start & End Frame Control',
        feature2Description: 'Allows users to upload both a start image and an end image, and Kling O1 will automatically generate natural, smooth transition animations between these two frames. This is crucial for creating seamless scene transitions, object morphing, or connecting two different shots, greatly enhancing narrative coherence.',
        feature3Title: 'Multi-Subject Consistency',
        feature3Description: 'Solves the problem of "characters changing between shots" in AI videos. Kling O1 has a "director\'s memory" capability, understanding and remembering character or object features (such as faces, clothing, props) uploaded by users, maintaining highly consistent appearance across different shots and camera movements. Perfect for creating continuous short dramas or advertisements.',
        feature4Title: 'Video Style Repainting',
        feature4Description: 'While keeping the original video\'s structure, composition, and motion completely unchanged, render the entire video into a new artistic style through text prompts. Whether converting live-action footage to anime, or changing daytime scenes to cyberpunk nightscapes, it can be done with one click.',
        feature5Title: 'Motion Transfer',
        feature5Description: 'Extract motion patterns (such as camera movements or character actions) from a reference video and apply them to entirely new subjects or scenes. This means you can use a simple phone recording as "motion capture" material and have AI-generated high-quality characters perform exactly the same movements.',

        // How to use section
        howToUseTitle: 'How to Use Kling O1 on WeryAI',
        step1Title: 'Select Model',
        step1Description: 'Select the Kling O1 model in the AI video tool.',
        step2Title: 'Select Function',
        step2Description: 'Choose Start/End Frame Generation or Multi-Image Reference Generation.',
        step3Title: 'Input Content',
        step3Description: 'Upload reference images and enter prompts.',
        step4Title: 'Generate Video',
        step4Description: 'Click the Generate button, wait, and download your video.',

        // YouTube videos section
        youtubeTitle: 'Exciting Video Introductions About Kling O1',

        // X Posts section
        xPostsTitle: 'Explore More Discussions About Kling O1',

        // Explore other models section
        exploreModelsTitle: 'Explore Other Video Models on WeryAI',
        kling25Title: 'Kling 2.5 Turbo Pro',
        runwayTitle: 'Runway Gen-4.5',
        lumaTitle: 'Luma Dream Machine',

        // FAQ section
        faqTitle: 'Frequently Asked Questions',

        // CTA section
        ctaTitle: 'Experience Kling O1 Now',
        ctaDescription: 'Start creating unified multimodal AI videos for free on WeryAI',
        ctaButton: 'Start Generating Videos',
        ctaDisclaimer: 'No credit card required, register to use',


        // YouTube video titles
        youtubeVideo1Title: 'Kling O1 - Official Demo',
        youtubeVideo2Title: 'Kling O1 - Features Overview',
        youtubeVideo3Title: 'Kling O1 - Tutorial',
        youtubeVideo4Title: 'Kling O1 - Advanced Techniques',
        youtubeVideo5Title: 'Kling O1 - Creative Workflow',
        youtubeVideo6Title: 'Kling O1 - Best Practices',

        // Alt text
        logoAlt: 'Kling',

        // Structured Data
        structuredDataName: 'Kling O1 AI Video Generator',
        structuredDataDescription: 'Kling O1 is the industry\'s first unified multimodal video model supporting natural language video editing, start & end frame control, and multi-subject consistency',
        structuredDataFeature1: 'Natural Language Video Editing',
        structuredDataFeature2: 'Start & End Frame Control',
        structuredDataFeature3: 'Multi-Subject Consistency',
        structuredDataFeature4: 'Video Style Repainting',
        structuredDataFeature5: 'Motion Transfer',
    },
    es: {
        // SEO Meta
        pageTitle: 'Generador de Videos AI Kling O1 - Modelo de Video Multimodal Unificado, Edición en Lenguaje Natural, Coherencia de Personajes',
        pageDescription: 'Experimenta Kling O1, la última creación de Kling AI de Kuaishou, el primer modelo de video multimodal unificado del sector. Admite edición de video en lenguaje natural, control de fotogramas inicial y final y generación con coherencia multi-sujeto. Prueba ahora en WeryAI.',
        pageKeywords: 'Kling O1, modelo multimodal unificado, edición de video, coherencia de personajes, generador de videos AI, edición en lenguaje natural, WeryAI',

        // 生成器部分
        generatorTitle: 'Generador de Videos Kling O1',
        generatorDescription: 'WeryAI ahora integra profundamente el modelo Kling O1, Kling O1 es el primer modelo de video multimodal unificado (Unified Multimodal Video Model) del sector, lanzado por Kling AI de Kuaishou en diciembre de 2025. A diferencia de los modelos tradicionales de video a partir de texto, Kling O1 adopta una arquitectura MVL (Lenguaje Visual Multimodal) revolucionaria que rompe las barreras entre la generación y la edición de videos. Permite a los usuarios modificar directamente elementos, luces o movimientos en videos existentes a través de conversaciones en lenguaje natural, sin necesidad de máscaras complejas o software de postproducción. No solo genera videos de alta calidad, sino que también resuelve los dos grandes problemas de los videos AI: la "coherencia de personajes" y la "edición precisa", convirtiéndose en una herramienta integral para que los creadores pasen de la idea a la obra final. ¡Ven a probar Kling O1 gratis en WeryAI y redefine tu flujo de trabajo de postproducción de videos con una sola frase!',

        // 标签页
        tabImageToVideo: 'Imagen a Video',
        tabTextToVideo: 'Texto a Video',

        // 核心功能部分
        coreFeaturesTitle: 'Características Principales de Kling O1',

        // 功能特点
        feature1Title: 'Edición de Video en Lenguaje Natural (Video Inpainting & Editing)',
        feature1Description: 'Esta es la función más revolucionaria de Kling O1. No necesitas usar software profesional de edición de video para hacer rotoscopia fotograma por fotograma, solo ingresa instrucciones de texto sencillas y el modelo entenderá el contenido del video, eliminará objetos con precisión, reemplazará fondos o cambiará el color de elementos específicos, manteniendo perfectamente la trayectoria de movimiento y la relación de luces y sombras originales del video.',
        feature2Title: 'Control de Coherencia de Fotogramas Inicial y Final (Start & End Frame Control)',
        feature2Description: 'Permite a los usuarios subir una imagen inicial y una imagen final simultáneamente, y Kling O1 generará automáticamente una animación de transición natural y fluida entre estos dos fotogramas. Esto es crucial para crear transiciones de escenas fluidas, deformaciones de objetos o conectar dos tomas diferentes, mejorando enormemente la coherencia narrativa.',
        feature3Title: 'Generación con Coherencia Multi-Sujeto (Multi-Subject Consistency)',
        feature3Description: 'Resuelve el problema de que "la persona cambia al cambiar de toma" en los videos AI. Kling O1 tiene una capacidad similar a la "memoria de director", capaz de entender y recordar las características de los personajes u objetos subidos por el usuario (como rostro, ropa, accesorios), manteniendo una apariencia altamente consistente en diferentes tomas y movimientos de cámara, ideal para la creación de series cortas continuas o anuncios publicitarios.',
        feature4Title: 'Transferencia y Repintado de Estilo de Video (Video Style Repainting)',
        feature4Description: 'Manteniendo intacta la estructura, composición y movimiento originales del video, se renderiza el video completo en un nuevo estilo artístico a través de indicaciones de texto. Ya sea convertir un video grabado en anime de dos dimensiones o cambiar una escena diurna por una noche cyberpunk, se puede lograr con un solo clic.',
        feature5Title: 'Reproducción de Trayectoria de Movimiento (Motion Transfer)',
        feature5Description: 'Extrae el patrón de movimiento de un video de referencia (como el estilo de movimiento de cámara o la acción de una persona) y lo aplica a un sujeto o escena completamente nuevo. Esto significa que puedes usar una simple grabación de teléfono móvil como material de "captura de movimiento" para que un personaje de alta calidad generado por AI realice exactamente la misma acción.',

        // 如何使用部分
        howToUseTitle: 'Cómo usar Kling O1 en WeryAI',
        step1Title: 'Seleccionar modelo',
        step1Description: 'Seleccione el modelo Kling O1 en la herramienta de video AI.',
        step2Title: 'Seleccionar función',
        step2Description: 'Elija generación de fotogramas inicial/final o generación con referencia de múltiples imágenes.',
        step3Title: 'Ingresar contenido',
        step3Description: 'Suba imágenes de referencia e ingrese los prompts.',
        step4Title: 'Generar video',
        step4Description: 'Haga clic en el botón Generar, espere y descargue su video.',

        // YouTube 视频部分
        youtubeTitle: 'Excelentes Videos Introductorios sobre Kling O1',

        // X Posts 部分
        xPostsTitle: 'Explora Más Discusiones sobre Kling O1',

        // 探索其他模型部分
        exploreModelsTitle: 'Explorar otros modelos de video en WeryAI',
        kling25Title: 'Kling 2.5 Turbo Pro',
        runwayTitle: 'Runway Gen-4.5',
        lumaTitle: 'Luma Dream Machine',

        // FAQ 部分
        faqTitle: 'Preguntas Frecuentes',

        // CTA 部分
        ctaTitle: 'Prueba Kling O1 Ahora',
        ctaDescription: 'Comienza a crear videos AI multimodales unificados gratis en WeryAI',
        ctaButton: 'Comenzar a Generar Video',
        ctaDisclaimer: 'No se requiere tarjeta de crédito, solo regístrate para usar',

        // YouTube 视频标题
        youtubeVideo1Title: 'Kling O1 - Demostración Oficial',
        youtubeVideo2Title: 'Kling O1 - Vista General de Funciones',
        youtubeVideo3Title: 'Kling O1 - Tutorial',
        youtubeVideo4Title: 'Kling O1 - Técnicas Avanzadas',
        youtubeVideo5Title: 'Kling O1 - Flujo de Trabajo Creativo',
        youtubeVideo6Title: 'Kling O1 - Mejores Prácticas',

        // Alt 文本
        logoAlt: 'Kling',

        // Structured Data
        structuredDataName: 'Generador de Videos AI Kling O1',
        structuredDataDescription: 'Kling O1 es el primer modelo de video multimodal unificado del sector, admite edición de video en lenguaje natural, control de fotogramas inicial y final y coherencia multi-sujeto',
        structuredDataFeature1: 'Edición de Video en Lenguaje Natural',
        structuredDataFeature2: 'Control de Fotogramas Inicial y Final',
        structuredDataFeature3: 'Coherencia Multi-Sujeto',
        structuredDataFeature4: 'Repintado de Estilo de Video',
        structuredDataFeature5: 'Reproducción de Trayectoria de Movimiento',
    },
    fr: {
        // SEO Meta
        pageTitle: 'Générateur de Vidéos IA Kling O1 - Modèle Vidéo Multimodal Unifié, Édition en Langage Naturel, Cohérence des Personnages',
        pageDescription: 'Découvrez Kling O1, la dernière création de Kling AI de Kuaishou, le premier modèle vidéo multimodal unifié du secteur. Prend en charge l\'édition de vidéos en langage naturel, le contrôle des images de début et de fin et la génération avec cohérence multi-sujets. Essayez maintenant sur WeryAI.',
        pageKeywords: 'Kling O1, modèle multimodal unifié, édition de vidéo, cohérence des personnages, générateur de vidéos IA, édition en langage naturel, WeryAI',

        // 生成器部分
        generatorTitle: 'Générateur de Vidéos Kling O1',
        generatorDescription: 'WeryAI intègre désormais en profondeur le modèle Kling O1, Kling O1 est le premier modèle vidéo multimodal unifié (Unified Multimodal Video Model) du secteur, lancé par Kling AI de Kuaishou en décembre 2025. Contrairement aux modèles traditionnels de vidéos à partir de texte, Kling O1 adopte une architecture MVL (Langage Visuel Multimodal) révolutionnaire qui brise les barrières entre la génération et l\'édition de vidéos. Il permet aux utilisateurs de modifier directement des éléments, lumières ou mouvements dans des vidéos existantes via des conversations en langage naturel, sans besoin de masques complexes ou de logiciels de post-production. Il génère non seulement des vidéos de haute qualité, mais résout également les deux grands problèmes des vidéos IA : la "cohérence des personnages" et l\'"édition précise", devenant un outil tout-en-un pour que les créateurs passent de l\'idée à la réalisation finale. Venez essayer Kling O1 gratuitement sur WeryAI et redéfinissez votre flux de travail de post-production vidéo avec une seule phrase !',

        // 标签页
        tabImageToVideo: 'Image vers Vidéo',
        tabTextToVideo: 'Texte vers Vidéo',

        // 核心功能部分
        coreFeaturesTitle: 'Caractéristiques Principales de Kling O1',

        // 功能特点
        feature1Title: 'Édition de Vidéo en Langage Naturel (Video Inpainting & Editing)',
        feature1Description: 'C\'est la fonction la plus révolutionnaire de Kling O1. Vous n\'avez pas besoin d\'utiliser un logiciel professionnel d\'édition de vidéo pour faire du rotoscoping image par image, il suffit d\'entrer des instructions textuelles simples et le modèle comprendra le contenu de la vidéo, supprimera des objets avec précision, remplacera des fonds ou changera la couleur d\'éléments spécifiques, tout en conservant parfaitement la trajectoire de mouvement et la relation lumière-ombre originales de la vidéo.',
        feature2Title: 'Contrôle de Cohérence des Images de Début et de Fin (Start & End Frame Control)',
        feature2Description: 'Permet aux utilisateurs de télécharger simultanément une image de départ et une image de fin, et Kling O1 générera automatiquement une animation de transition naturelle et fluide entre ces deux images. C\'est crucial pour créer des transitions de scènes fluides, des déformations d\'objets ou connecter deux prises différentes, améliorant considérablement la cohérence narrative.',
        feature3Title: 'Génération avec Cohérence Multi-Sujets (Multi-Subject Consistency)',
        feature3Description: 'Résout le problème où "la personne change quand on change de prise" dans les vidéos IA. Kling O1 a une capacité similaire à une "mémoire de réalisateur", capable de comprendre et de se souvenir des caractéristiques des personnages ou objets téléchargés par l\'utilisateur (tels que le visage, les vêtements, les accessoires), conservant une apparence hautement cohérente dans différentes prises et mouvements de caméra, idéal pour la création de séries courtes continues ou de publicités.',
        feature4Title: 'Transfert et Redessin de Style Vidéo (Video Style Repainting)',
        feature4Description: 'En conservant intacte la structure, la composition et le mouvement originaux de la vidéo, rend la vidéo entière dans un nouveau style artistique via des indications textuelles. Qu\'il s\'agisse de convertir une vidéo filmée en anime 2D ou de transformer une scène diurna en une nuit cyberpunk, cela peut être réalisé en un seul clic.',
        feature5Title: 'Réplication de Trajectoire de Mouvement (Motion Transfer)',
        feature5Description: 'Extrait le modèle de mouvement d\'une vidéo de référence (tel que le style de mouvement de caméra ou l\'action d\'une personne) et l\'applique à un sujet ou une scène complètement nouveau. Cela signifie que vous pouvez utiliser une simple prise de vue mobile comme matériel de "captation de mouvement" pour faire réaliser la même action à un personnage de haute qualité généré par IA.',

        // 如何使用部分
        howToUseTitle: 'Comment utiliser Kling O1 sur WeryAI',
        step1Title: 'Sélectionner le modèle',
        step1Description: 'Sélectionnez le modèle Kling O1 dans l\'outil vidéo IA.',
        step2Title: 'Sélectionner la fonctionnalité',
        step2Description: 'Choisissez la génération d\'images de début/fin ou la génération par référence multi-images.',
        step3Title: 'Saisir le contenu',
        step3Description: 'Téléchargez des images de référence et saisissez des prompts.',
        step4Title: 'Générer la vidéo',
        step4Description: 'Cliquez sur le bouton Générer, patientez et téléchargez votre vidéo.',

        // YouTube 视频部分
        youtubeTitle: 'Excellentes Vidéos de Présentation sur Kling O1',

        // X Posts 部分
        xPostsTitle: 'Découvrez Plus de Discussions sur Kling O1',

        // 探索其他模型部分
        exploreModelsTitle: 'Découvrez d\'autres modèles vidéo sur WeryAI',
        kling25Title: 'Kling 2.5 Turbo Pro',
        runwayTitle: 'Runway Gen-4.5',
        lumaTitle: 'Luma Dream Machine',

        // FAQ 部分
        faqTitle: 'Questions Fréquentes',

        // CTA 部分
        ctaTitle: 'Essayez Kling O1 Maintenant',
        ctaDescription: 'Commencez à créer des vidéos IA multimodales unifiées gratuitement sur WeryAI',
        ctaButton: 'Commencer à Générer une Vidéo',
        ctaDisclaimer: 'Aucune carte de crédit requise, inscrivez-vous et utilisez',

        // YouTube 视频标题
        youtubeVideo1Title: 'Kling O1 - Démonstration Officielle',
        youtubeVideo2Title: 'Kling O1 - Aperçu des Fonctions',
        youtubeVideo3Title: 'Kling O1 - Tutoriel',
        youtubeVideo4Title: 'Kling O1 - Techniques Avancées',
        youtubeVideo5Title: 'Kling O1 - Flux de Travail Créatif',
        youtubeVideo6Title: 'Kling O1 - Meilleures Pratiques',

        // Alt 文本
        logoAlt: 'Kling',

        // Structured Data
        structuredDataName: 'Générateur de Vidéos IA Kling O1',
        structuredDataDescription: 'Kling O1 est le premier modèle vidéo multimodal unifié du secteur, prenant en charge l\'édition de vidéo en langage naturel, le contrôle des images de début et de fin et la cohérence multi-sujets',
        structuredDataFeature1: 'Édition de Vidéo en Langage Naturel',
        structuredDataFeature2: 'Contrôle des Images de Début et de Fin',
        structuredDataFeature3: 'Cohérence Multi-Sujets',
        structuredDataFeature4: 'Redessin de Style Vidéo',
        structuredDataFeature5: 'Réplication de Trajectoire de Mouvement',
    },
    de: {
        // SEO Meta
        pageTitle: 'Kling O1 KI-Videogenerator - Einheitliches multimodales Videomodell, Natürlichsprachige Bearbeitung, Charakterkonsistenz',
        pageDescription: 'Erleben Sie Kling O1, das neueste Meisterwerk von Kling AI der Kuaishou, das erste einheitliche multimodale Videomodell der Branche. Unterstützt natürlichsprachige Videobearbeitung, Steuerung von Start- und Endbildern sowie Generierung mit Multi-Subjekt-Konsistenz. Jetzt auf WeryAI testen.',
        pageKeywords: 'Kling O1, einheitlich multimodal, Videobearbeitung, Charakterkonsistenz, KI-Videogenerator, natürlichsprachige Bearbeitung, WeryAI',

        // 生成器部分
        generatorTitle: 'Kling O1 Videogenerator',
        generatorDescription: 'WeryAI integriert jetzt das Modell Kling O1 tiefgreifend, Kling O1 ist das erste einheitliche multimodale Videomodell (Unified Multimodal Video Model) der Branche, das von Kling AI der Kuaishou im Dezember 2025 herausgebracht wurde. Im Gegensatz zu traditionellen Text-zu-Video-Modellen nutzt Kling O1 eine revolutionäre MVL (Multimodales visuelles Sprach)-Architektur, die die Grenzen zwischen Videogenerierung und -bearbeitung bricht. Es ermöglicht Benutzern, Elemente, Beleuchtung oder Bewegungen in bestehenden Videos direkt über natürlichsprachige Konversationen zu ändern, ohne komplexe Masken oder Nachbearbeitungssoftware. Es generiert nicht nur hochwertige Videos, sondern löst auch die beiden großen Probleme von KI-Videos: "Charakterkonsistenz" und "präzise Bearbeitung" – ein All-in-One-Werkzeug für Schöpfer, um von der Idee zum fertigen Produkt zu gelangen. Kommen Sie und testen Sie Kling O1 kostenlos auf WeryAI und neu definieren Sie Ihren Videopostproduktionsworkflow mit einem einzigen Satz!',

        // 标签页
        tabImageToVideo: 'Bild zu Video',
        tabTextToVideo: 'Text zu Video',

        // 核心功能部分
        coreFeaturesTitle: 'Hauptfunktionen von Kling O1',

        // 功能特点
        feature1Title: 'Natürlichsprachige Videobearbeitung (Video Inpainting & Editing)',
        feature1Description: 'Dies ist die revolutionärste Funktion von Kling O1. Sie müssen keine professionelle Videobearbeitungssoftware für Rotoscoping Frame für Frame verwenden – geben Sie einfach einfache Textanweisungen ein, und das Modell versteht den Videoinhalt, entfernt Objekte präzise, ersetzt Hintergründe oder ändert die Farbe bestimmter Elemente, während es die ursprüngliche Bewegungsbahn und das Licht-Schatten-Verhältnis des Videos perfekt beibehält.',
        feature2Title: 'Steuerung der Konsistenz von Start- und Endbildern (Start & End Frame Control)',
        feature2Description: 'Ermöglicht es Benutzern, gleichzeitig ein Startbild und ein Endbild hochzuladen – Kling O1 generiert automatisch eine natürliche und flüssige Übergangsanimation zwischen diesen beiden Frames. Dies ist entscheidend für die Erstellung flüssiger Szenenübergänge, Objektverformungen oder die Verbindung zweier unterschiedlicher Aufnahmen und verbessert die narrative Kohärenz erheblich.',
        feature3Title: 'Generierung mit Multi-Subjekt-Konsistenz (Multi-Subject Consistency)',
        feature3Description: 'Löst das Problem, dass "die Person wechselt, wenn die Aufnahme wechselt" in KI-Videos. Kling O1 verfügt über eine "Regisseur-Erinnerungs"-Funktion: Es versteht und speichert die Merkmale von Charakteren oder Objekten, die der Benutzer hochlädt (z. B. Gesicht, Kleidung, Requisiten), und behält ein hochgradig konsistentes Aussehen bei unterschiedlichen Aufnahmen und Kamerabewegungen – ideal für die Erstellung fortlaufender Kurzserien oder Werbespots.',
        feature4Title: 'Video-Stil-Transfer und -Neumarstellung (Video Style Repainting)',
        feature4Description: 'Behält die ursprüngliche Struktur, Komposition und Bewegung des Videos vollständig bei und rendert das gesamte Video in einem neuen künstlerischen Stil mithilfe von Textanweisungen. Ob Sie ein aufgenommenes Video in einen 2D-Anime umwandeln oder eine Tageszene in eine Cyberpunk-Nacht ändern – alles mit einem einzigen Klick möglich.',
        feature5Title: 'Wiederholung von Bewegungsbahnen (Motion Transfer)',
        feature5Description: 'Extrahiert das Bewegungsmuster aus einem Referenzvideo (z. B. Kameraführung oder menschliche Bewegungen) und wendet es auf ein völlig neues Subjekt oder eine neue Szene an. Das bedeutet: Sie können eine einfache Handyaufnahme als "Bewegungsaufzeichnung"-Material verwenden, damit ein hochwertiger KI-generierter Charakter genau die gleichen Bewegungen ausführt.',

        // 如何使用部分
        howToUseTitle: 'So verwenden Sie Kling O1 auf WeryAI',
        step1Title: 'Modell auswählen',
        step1Description: 'Wählen Sie das Kling O1-Modell im KI-Video-Tool aus.',
        step2Title: 'Funktion auswählen',
        step2Description: 'Wählen Sie Start-/Endbild-Generierung oder Generierung mit Mehrbild-Referenz.',
        step3Title: 'Inhalt eingeben',
        step3Description: 'Laden Sie Referenzbilder hoch und geben Sie Prompts ein.',
        step4Title: 'Video generieren',
        step4Description: 'Klicken Sie auf die Schaltfläche Generieren, warten Sie und laden Sie Ihr Video herunter.',

        // YouTube 视频部分
        youtubeTitle: 'Exzellente Videoeinführungen zu Kling O1',

        // X Posts 部分
        xPostsTitle: 'Entdecken Sie mehr Diskussionen zu Kling O1',

        // 探索其他模型部分
        exploreModelsTitle: 'Entdecken Sie andere Videomodelle auf WeryAI',
        kling25Title: 'Kling 2.5 Turbo Pro',
        runwayTitle: 'Runway Gen-4.5',
        lumaTitle: 'Luma Dream Machine',

        // FAQ 部分
        faqTitle: 'Häufig gestellte Fragen',

        // CTA 部分
        ctaTitle: 'Testen Sie Kling O1 jetzt',
        ctaDescription: 'Beginnen Sie kostenlos mit der Erstellung einheitlicher multimodaler KI-Videos auf WeryAI',
        ctaButton: 'Video generieren starten',
        ctaDisclaimer: 'Keine Kreditkarte erforderlich, einfach registrieren und nutzen',

        // YouTube 视频标题
        youtubeVideo1Title: 'Kling O1 - Offizielle Demonstration',
        youtubeVideo2Title: 'Kling O1 - Funktionsübersicht',
        youtubeVideo3Title: 'Kling O1 - Tutorial',
        youtubeVideo4Title: 'Kling O1 - Fortgeschrittene Techniken',
        youtubeVideo5Title: 'Kling O1 - Kreativer Workflow',
        youtubeVideo6Title: 'Kling O1 - Beste Praktiken',

        // Alt 文本
        logoAlt: 'Kling',

        // Structured Data
        structuredDataName: 'Kling O1 KI-Videogenerator',
        structuredDataDescription: 'Kling O1 ist das erste einheitliche multimodale Videomodell der Branche, das natürlichsprachige Videobearbeitung, Steuerung von Start- und Endbildern sowie Multi-Subjekt-Konsistenz unterstützt',
        structuredDataFeature1: 'Natürlichsprachige Videobearbeitung',
        structuredDataFeature2: 'Steuerung von Start- und Endbildern',
        structuredDataFeature3: 'Multi-Subjekt-Konsistenz',
        structuredDataFeature4: 'Video-Stil-Neumarstellung',
        structuredDataFeature5: 'Wiederholung von Bewegungsbahnen',
    },
    ru: {
        // SEO Meta
        pageTitle: 'Kling O1 AI Генератор видео - Единая мультимодальная видеомодель, редактирование естественным языком, согласованность персонажей',
        pageDescription: 'Попробуйте новое творение Kling AI от Kuaishou — Kling O1, первую в отрасли единую мультимодальную видеомодель, поддерживающую редактирование видео естественным языком, контроль начальных и конечных кадров и генерацию с согласованностью нескольких субъектов. Попробуйте прямо сейчас на WeryAI.',
        pageKeywords: 'Kling O1, Клинг O1, единая мультимодальность, редактирование видео, согласованность персонажей, AI генератор видео, редактирование естественным языком, WeryAI',

        // 生成器部分
        generatorTitle: 'Kling O1 Генератор видео',
        generatorDescription: 'WeryAI теперь глубоко интегрировал модель Kling O1, Kling O1 — это первая в отрасли единая мультимодальная видеомодель (Unified Multimodal Video Model), презентованная Kling AI от Kuaishou в декабре 2025 года. В отличие от традиционных моделей генерации видео из текста, Kling O1 использует революционную архитектуру MVL (мультимодальный визуальный язык), устраняя границы между генерацией и редактированием видео. Пользователи могут напрямую изменять элементы, освещение или движения в существующих видео с помощью диалогов на естественном языке, без необходимости сложных масок или постпроизводственных программ. Она не только генерирует высококачественное видео, но и решает две основные проблемы AI-видео: "согласованность персонажей" и "точное редактирование", становясь универсальным инструментом для создателей от идеи до готового ролика. Попробуйте Kling O1 бесплатно на WeryAI и переопределите ваш рабочий процесс постпроизводства видео одним предложением!',

        // 标签页
        tabImageToVideo: 'Изображение в видео',
        tabTextToVideo: 'Текст в видео',

        // 核心功能部分
        coreFeaturesTitle: 'Основные функции Kling O1',

        // 功能特点
        feature1Title: 'Редактирование видео естественным языком (Video Inpainting & Editing)',
        feature1Description: 'Это самая революционная функция Kling O1. Вам не нужно использовать профессиональное видеоредакционное программное обеспечение для создания масок кадр за кадром (Rotoscoping) — достаточно ввести простые текстовые команды, и модель поймет содержание видео, точно удалит объекты, заменит фон или изменит цвет отдельных элементов, сохраняя при этом исходную траекторию движения и световые отношения в видео.',
        feature2Title: 'Контроль согласованности начальных и конечных кадров (Start & End Frame Control)',
        feature2Description: 'Позволяет пользователю одновременно загружать начальное и конечное изображение — Kling O1 автоматически генерирует естественную, плавную переходную анимацию между этими кадрами. Это критически важно для создания плавных сценческих переходов, деформации объектов или соединения двух разных кадров, значительно повышая связность повествования.',
        feature3Title: 'Генерация с согласованностью нескольких субъектов (Multi-Subject Consistency)',
        feature3Description: 'Решает проблему AI-видео "персонаж меняется при смене кадра". Kling O1 обладает способностью, похожей на "режиссерскую память" — она понимает и запоминает характеристики персонажей или объектов, загруженных пользователем (например, черты лица, одежда, реквизит), сохраняя высокую согласованность внешнего вида при разных кадрах и камерных движениях. Идеально подходит для создания последовательных коротких сериалов или рекламы.',
        feature4Title: 'Перенос и перерисовка стиля видео (Video Style Repainting)',
        feature4Description: 'При сохранении исходной структуры, композиции и движений видео полностью перерисовывает его в совершенно новом художественном стиле с помощью текстовых подсказок. Буквально одним кликом можно превратить реальное видео в аниме в стиле двух измерений или изменить дневную сцену на киберпанк ночной пейзаж.',
        feature5Title: 'Копирование траектории движения (Motion Transfer)',
        feature5Description: 'Извлекает паттерн движения из эталонного видео (например, способ камерного движения или движения персонажа) и применяет его к совершенно новому субъекту или сцене. Это означает, что вы можете использовать простое видео, снятое на телефон, как материал для "капчура движений", чтобы AI-сгенерированный высококачественный персонаж выполнял точно такие же движения.',

        // 如何使用部分
        howToUseTitle: 'Как использовать Kling O1 на WeryAI',
        step1Title: 'Выберите модель',
        step1Description: 'Выберите модель Kling O1 в инструменте AI-видео.',
        step2Title: 'Выберите функцию',
        step2Description: 'Выберите генерацию по начальному/конечному кадру или генерацию по нескольким изображениям.',
        step3Title: 'Введите содержание',
        step3Description: 'Загрузите справочные изображения и введите подсказки.',
        step4Title: 'Создать видео',
        step4Description: 'Нажмите кнопку «Создать», подождите и скачайте ваше видео.',

        // YouTube 视频部分
        youtubeTitle: 'Интересные видеоролики о Kling O1',

        // X Posts 部分
        xPostsTitle: 'Откройте для себя больше обсуждений о Kling O1',

        // 探索其他模型部分
        exploreModelsTitle: 'Изучите другие видеомодели на WeryAI',
        kling25Title: 'Kling 2.5 Turbo Pro',
        runwayTitle: 'Runway Gen-4.5',
        lumaTitle: 'Luma Dream Machine',

        // FAQ 部分
        faqTitle: 'Часто задаваемые вопросы',

        // CTA 部分
        ctaTitle: 'Попробуйте Kling O1 прямо сейчас',
        ctaDescription: 'Начните создавать единые мультимодальные AI-видео бесплатно на WeryAI',
        ctaButton: 'Начать генерацию видео',
        ctaDisclaimer: 'Без кредитной карты — достаточно зарегистрироваться',

        // YouTube 视频标题
        youtubeVideo1Title: 'Kling O1 - Официальная демонстрация',
        youtubeVideo2Title: 'Kling O1 - Обзор функций',
        youtubeVideo3Title: 'Kling O1 - Учебник',
        youtubeVideo4Title: 'Kling O1 - Продвинутые приемы',
        youtubeVideo5Title: 'Kling O1 - Творческий рабочий процесс',
        youtubeVideo6Title: 'Kling O1 - Лучшие практики',

        // Alt 文本
        logoAlt: 'Kling',

        // Structured Data
        structuredDataName: 'Kling O1 AI Генератор видео',
        structuredDataDescription: 'Kling O1 — первая в отрасли единая мультимодальная видеомодель, поддерживающая редактирование видео естественным языком, контроль начальных и конечных кадров и согласованность нескольких субъектов',
        structuredDataFeature1: 'Редактирование видео естественным языком',
        structuredDataFeature2: 'Контроль начальных и конечных кадров',
        structuredDataFeature3: 'Согласованность нескольких субъектов',
        structuredDataFeature4: 'Перерисовка стиля видео',
        structuredDataFeature5: 'Копирование траектории движения',
    },
    pt: {
        // SEO Meta
        pageTitle: 'Gerador de Vídeo AI Kling O1 - Modelo de Vídeo Multimodal Unificado, Edição em Linguagem Natural, Consistência de Personagens',
        pageDescription: 'Experimente o Kling O1, a nova criação da Kling AI da Kuaishou, o primeiro modelo de vídeo multimodal unificado do setor, com suporte a edição de vídeo em linguagem natural, controle de quadros inicial e final e geração com consistência de múltiplos sujeitos. Experimente agora na WeryAI.',
        pageKeywords: 'Kling O1, Kling O1, multimodal unificado, edição de vídeo, consistência de personagens, gerador de vídeo AI, edição em linguagem natural, WeryAI',

        // 生成器部分
        generatorTitle: 'Gerador de Vídeo Kling O1',
        generatorDescription: 'O WeryAI agora integra profundamente o modelo Kling O1, lançado pela Kling AI da Kuaishou em dezembro de 2025. Diferente dos modelos tradicionais de geração de vídeo a partir de texto, o Kling O1 adota uma arquitetura revolucionária MVL (Linguagem Visual Multimodal), que quebra as barreiras entre geração e edição de vídeo, permitindo que os usuários modifiquem diretamente elementos, iluminação ou movimentos em vídeos existentes por meio de diálogos em linguagem natural, sem a necessidade de máscaras complexas ou softwares de pós-produção. Ele não apenas gera vídeos de alta qualidade, mas também resolve dois grandes pontos problemáticos dos vídeos AI: "consistência de personagens" e "edição precisa", sendo um artefato all-in-one para criadores transformarem ideias em vídeos finalizados. Venha experimentar o Kling O1 gratuitamente na WeryAI e redefina seu fluxo de trabalho de pós-produção de vídeo com uma única frase!',

        // 标签页
        tabImageToVideo: 'Imagem para Vídeo',
        tabTextToVideo: 'Texto para Vídeo',

        // 核心功能部分
        coreFeaturesTitle: 'Características Principais do Kling O1',

        // 功能特点
        feature1Title: 'Edição de Vídeo em Linguagem Natural (Video Inpainting & Editing)',
        feature1Description: 'Esta é a função mais revolucionária do Kling O1. Você não precisa usar softwares profissionais de edição de vídeo para criar máscaras frame a frame (Rotoscoping) — basta inserir comandos de texto simples, e o modelo compreenderá o conteúdo do vídeo, removerá objetos com precisão, substituirá o fundo ou alterará a cor de elementos específicos, mantendo perfeitamente a trajetória de movimento original e as relações de iluminação do vídeo.',
        feature2Title: 'Controle de Consistência de Quadros Inicial e Final (Start & End Frame Control)',
        feature2Description: 'Permite que o usuário faça upload simultaneamente de uma imagem inicial e uma imagem final — o Kling O1 gerará automaticamente uma animação de transição natural e fluida entre esses dois quadros. Isso é fundamental para criar transições de cena suaves, deformação de objetos ou conexão de duas tomadas diferentes, elevando significativamente a coerência narrativa.',
        feature3Title: 'Geração com Consistência de Múltiplos Sujeitos (Multi-Subject Consistency)',
        feature3Description: 'Resolve o problema dos vídeos AI de "o personagem muda quando a tomada muda". O Kling O1 possui uma capacidade semelhante a "memória de diretor", podendo compreender e lembrar características de personagens ou objetos enviados pelo usuário (como rosto, roupa, adereços), mantendo uma aparência altamente consistente em diferentes tomadas e movimentos de câmera, sendo ideal para a criação de seriados curtos contínuos ou anúncios.',
        feature4Title: 'Transferência e Repintura de Estilo de Vídeo (Video Style Repainting)',
        feature4Description: 'Mantendo a estrutura original, composição e movimentos do vídeo intactos, renderiza o vídeo inteiro em um novo estilo artístico por meio de dicas de texto. Seja transformar um vídeo filmado em anime 2D, ou alterar uma cena diurna para uma noite cyberpunk, tudo pode ser feito com um clique.',
        feature5Title: 'Reprodução de Trajetória de Movimento (Motion Transfer)',
        feature5Description: 'Extrai um padrão de movimento de um vídeo de referência (como estilo de movimento de câmera ou ação de pessoa) e aplica-o a um novo sujeito ou cenário. Isso significa que você pode usar um simples vídeo filmado no celular como material de "captura de movimento", fazendo com que um personagem de alta qualidade gerado por AI execute exatamente a mesma ação.',

        // 如何使用部分
        howToUseTitle: 'Como usar o Kling O1 na WeryAI',
        step1Title: 'Selecionar Modelo',
        step1Description: 'Selecione o modelo Kling O1 na ferramenta de vídeo de IA.',
        step2Title: 'Selecionar Função',
        step2Description: 'Escolha geração de quadros inicial/final ou geração com referência de várias imagens.',
        step3Title: 'Inserir Conteúdo',
        step3Description: 'Faça upload de imagens de referência e insira os prompts.',
        step4Title: 'Gerar Vídeo',
        step4Description: 'Clique no botão Gerar, aguarde e baixe seu vídeo.',

        // YouTube 视频部分
        youtubeTitle: 'Excelentes Vídeos de Apresentação sobre o Kling O1',

        // X Posts 部分
        xPostsTitle: 'Explore Mais Discussões sobre o Kling O1',

        // 探索其他模型部分
        exploreModelsTitle: 'Explore Outros Modelos de Vídeo na WeryAI',
        kling25Title: 'Kling 2.5 Turbo Pro',
        runwayTitle: 'Runway Gen-4.5',
        lumaTitle: 'Luma Dream Machine',

        // FAQ 部分
        faqTitle: 'Perguntas Frequentes',

        // CTA 部分
        ctaTitle: 'Experimente o Kling O1 Agora',
        ctaDescription: 'Comece a criar vídeos AI multimodais unificados gratuitamente na WeryAI',
        ctaButton: 'Começar a Gerar Vídeo',
        ctaDisclaimer: 'Sem cartão de crédito, basta se registrar para usar',

        // YouTube 视频标题
        youtubeVideo1Title: 'Kling O1 - Demonstração Oficial',
        youtubeVideo2Title: 'Kling O1 - Visão Geral de Funcionalidades',
        youtubeVideo3Title: 'Kling O1 - Tutorial',
        youtubeVideo4Title: 'Kling O1 - Técnicas Avançadas',
        youtubeVideo5Title: 'Kling O1 - Fluxo de Trabalho Criativo',
        youtubeVideo6Title: 'Kling O1 - Melhores Práticas',

        // Alt 文本
        logoAlt: 'Kling',

        // Structured Data
        structuredDataName: 'Gerador de Vídeo AI Kling O1',
        structuredDataDescription: 'O Kling O1 é o primeiro modelo de vídeo multimodal unificado do setor, com suporte a edição de vídeo em linguagem natural, controle de quadros inicial e final e consistência de múltiplos sujeitos',
        structuredDataFeature1: 'Edição de Vídeo em Linguagem Natural',
        structuredDataFeature2: 'Controle de Quadros Inicial e Final',
        structuredDataFeature3: 'Consistência de Múltiplos Sujeitos',
        structuredDataFeature4: 'Repintura de Estilo de Vídeo',
        structuredDataFeature5: 'Reprodução de Trajetória de Movimento',
    },
    it: {
        // SEO Meta
        pageTitle: 'Generatore di Video AI Kling O1 - Modello Video Multimodale Unificato, Modifica in Linguaggio Naturale, Coerenza dei Personaggi',
        pageDescription: 'Prova il Kling O1, l\'ultima creazione di Kling AI di Kuaishou, il primo modello video multimodale unificato del settore, con supporto alla modifica video in linguaggio naturale, controllo dei fotogrammi iniziale e finale e generazione con coerenza di più soggetti. Provalo subito su WeryAI.',
        pageKeywords: 'Kling O1, Kling O1, multimodale unificato, modifica video, coerenza dei personaggi, generatore di video AI, modifica in linguaggio naturale, WeryAI',

        // 生成器部分
        generatorTitle: 'Generatore di Video Kling O1',
        generatorDescription: 'WeryAI integra ora in profondità il modello Kling O1, presentato da Kling AI di Kuaishou nel dicembre 2025. A differenza dei tradizionali modelli di generazione video da testo, il Kling O1 adopta un\'architettura rivoluzionaria MVL (Linguaggio Visivo Multimodale), che rompe le barriere tra generazione e modifica video, permettendo agli utenti di modificare direttamente elementi, illuminazione o movimenti in video esistenti tramite dialoghi in linguaggio naturale, senza la necessità di maschere complesse o software di post-produzione. Non solo genera video di alta qualità, ma risolve anche due grandi punti deboli dei video AI: "coerenza dei personaggi" e "modifica precisa", diventando un artefatto all-in-one per i creatori per passare dall\'idea al video finale. Vieni a provare il Kling O1 gratuitamente su WeryAI e ridefinisci il tuo flusso di lavoro di post-produzione video con una sola frase!',

        // 标签页
        tabImageToVideo: 'Immagine a Video',
        tabTextToVideo: 'Testo a Video',

        // 核心功能部分
        coreFeaturesTitle: 'Caratteristiche Principali del Kling O1',

        // 功能特点
        feature1Title: 'Modifica Video in Linguaggio Naturale (Video Inpainting & Editing)',
        feature1Description: 'Questa è la funzione più rivoluzionaria del Kling O1. Non è necessario utilizzare software professionali di editing video per creare maschere frame per frame (Rotoscoping) — basta inserire semplici comandi testuali e il modello comprenderà il contenuto del video, rimuoverà con precisione oggetti, sostituirà lo sfondo o cambierà il colore di elementi specifici, mantenendo perfettamente la traiettoria di movimento originale e le relazioni di illuminazione del video.',
        feature2Title: 'Controllo della Coerenza dei Fotogrammi Iniziale e Finale (Start & End Frame Control)',
        feature2Description: 'Permette all\'utente di caricare contemporaneamente un\'immagine iniziale e una finale — il Kling O1 genererà automaticamente un\'animazione di transizione naturale e fluida tra questi due fotogrammi. Questo è fondamentale per creare transizioni di scena fluide, deformazioni di oggetti o collegare due riprese diverse, elevando significativamente la coerenza narrativa.',
        feature3Title: 'Generazione con Coerenza di Più Soggetti (Multi-Subject Consistency)',
        feature3Description: 'Risolve il problema dei video AI "il personaggio cambia quando cambia la ripresa". Il Kling O1 possiede una capacità simile a "memoria di regista", capace di comprendere e ricordare le caratteristiche dei personaggi o oggetti caricati dall\'utente (come volto, abiti, oggetti di scena), mantenendo un\'aspetto altamente coerente in diverse riprese e movimenti di ripresa, ideale per la creazione di cortometraggi serializzati continui o spot pubblicitari.',
        feature4Title: 'Trasferimento e Ridesigno di Stile Video (Video Style Repainting)',
        feature4Description: 'Mantenendo intatta la struttura originale, la composizione e i movimenti del video, rirenderizza l\'intero video in un nuovo stile artistico tramite suggerimenti testuali. Che si tratti di trasformare un video girato in un anime 2D, o di cambiare una scena diurna in una notte cyberpunk, tutto è possibile con un solo clic.',
        feature5Title: 'Riproduzione della Traiettoria di Movimento (Motion Transfer)',
        feature5Description: 'Estrae un pattern di movimento da un video di riferimento (come stile di movimento di ripresa o azione di una persona) e lo applica a un nuovo soggetto o scena. Ciò significa che puoi usare un semplice video girato con il cellulare come materiale di "cattura del movimento", facendo sì che un personaggio di alta qualità generato da AI esegua la stessa azione.',

        // 如何使用部分
        howToUseTitle: 'Come usare Kling O1 su WeryAI',
        step1Title: 'Seleziona modello',
        step1Description: 'Seleziona il modello Kling O1 nello strumento video AI.',
        step2Title: 'Seleziona funzione',
        step2Description: 'Scegli generazione frame iniziale/finale o generazione riferimento multi-immagine.',
        step3Title: 'Inserisci contenuto',
        step3Description: 'Carica immagini di riferimento e inserisci i prompt.',
        step4Title: 'Genera video',
        step4Description: 'Clicca sul pulsante Genera, attendi e scarica il tuo video.',

        // YouTube 视频部分
        youtubeTitle: 'Eccellenti Video di Presentazione su Kling O1',

        // X Posts 部分
        xPostsTitle: 'Esplora Altre Discussioni su Kling O1',

        // 探索其他模型部分
        exploreModelsTitle: 'Esplora Altri Modelli Video su WeryAI',
        kling25Title: 'Kling 2.5 Turbo Pro',
        runwayTitle: 'Runway Gen-4.5',
        lumaTitle: 'Luma Dream Machine',

        // FAQ 部分
        faqTitle: 'Domande Frequenti',

        // CTA 部分
        ctaTitle: 'Prova Kling O1 Subito',
        ctaDescription: 'Inizia a creare video AI multimodali unificati gratuitamente su WeryAI',
        ctaButton: 'Inizia a Generare Video',
        ctaDisclaimer: 'Nessuna carta di credito necessaria, basta registrarsi per usare',

        // YouTube 视频标题
        youtubeVideo1Title: 'Kling O1 - Dimostrazione Ufficiale',
        youtubeVideo2Title: 'Kling O1 - Panoramica delle Funzionalità',
        youtubeVideo3Title: 'Kling O1 - Tutorial',
        youtubeVideo4Title: 'Kling O1 - Tecniche Avanzate',
        youtubeVideo5Title: 'Kling O1 - Flusso di Lavoro Creativo',
        youtubeVideo6Title: 'Kling O1 - Migliori Pratiche',

        // Alt 文本
        logoAlt: 'Kling',

        // Structured Data
        structuredDataName: 'Generatore di Video AI Kling O1',
        structuredDataDescription: 'Il Kling O1 è il primo modello video multimodale unificato del settore, con supporto alla modifica video in linguaggio naturale, controllo dei fotogrammi iniziale e finale e coerenza di più soggetti',
        structuredDataFeature1: 'Modifica Video in Linguaggio Naturale',
        structuredDataFeature2: 'Controllo dei Fotogrammi Iniziale e Finale',
        structuredDataFeature3: 'Coerenza di Più Soggetti',
        structuredDataFeature4: 'Ridesigno di Stile Video',
        structuredDataFeature5: 'Riproduzione della Traiettoria di Movimento',
    },
    ar: {
        // SEO Meta
        pageTitle: 'مولد الفيديو الاصطناعي Kling O1 - نموذج فيديو متعدد الأنماط الموحد، التحرير باللغة الطبيعية، الاتساق في الشخصيات',
        pageDescription: 'جرب Kling O1، آخر إبداع من Kling AI التابع لـ Kuaishou، أول نموذج فيديو متعدد الأنماط الموحد في السوق، يدعم التحرير من الفيديو باللغة الطبيعية، التحكم في الإطارات الأولية والنهائية، وتوليد محتوى مع الاتساق في الأجسام المتعددة. جربه الآن على WeryAI.',
        pageKeywords: 'Kling O1، كلينج O1، متعدد الأنماط الموحد، تحرير الفيديو، الاتساق في الشخصيات، مولد الفيديو الاصطناعي، التحرير باللغة الطبيعية، WeryAI',

        // 生成器部分
        generatorTitle: 'مولد الفيديو Kling O1',
        generatorDescription: 'يقوم WeryAI الآن بدمج نموذج Kling O1 بعمق، Kling O1 هو أول نموذج فيديو متعدد الأنماط الموحد (Unified Multimodal Video Model) في السوق، الذي أطلقته Kling AI التابعة لـ Kuaishou في ديسمبر 2025. على عكس النماذج التقليدية لتوليد الفيديو من النص، يُستخدم Kling O1 بنية MVL (اللغة البصرية متعددة الأنماط) الثورية، التي تكسر حوافز توليد وتحرير الفيديو، مما يسمح للمستخدمين بتعديل العناصر أو الإضاءة أو الحركات في الفيديوهات الموجودة مباشرة من خلال المحادثات باللغة الطبيعية، دون الحاجة إلى أقنعة معقدة أو برامج ما بعد الإنتاج. فهو لا يولد فقط فيديوهات عالية الجودة، بل يحل أيضًا مشكلتين رئيسيتين في الفيديوهات الاصطناعية: "الاتساق في الشخصيات" و"التحرير الدقيق"، ليصبح أداة شاملة للمبدعين لتحويل الأفكار إلى فيديوهات ناتجة. تعال جرب Kling O1 مجانًا على WeryAI وأعاد تعريف سير عمل ما بعد الإنتاج للفيديو بعبارة واحدة!',

        // 标签页
        tabImageToVideo: 'تحويل الصورة إلى فيديو',
        tabTextToVideo: 'تحويل النص إلى فيديو',

        // 核心功能部分
        coreFeaturesTitle: 'الميزات الرئيسية لـ Kling O1',

        // 功能特点
        feature1Title: 'تحرير الفيديو باللغة الطبيعية (Video Inpainting & Editing)',
        feature1Description: 'هذه هي أكثر الميزات ثورة لـ Kling O1. لا تحتاج إلى استخدام برامج تحرير الفيديو المهنية لإنشاء أقنعة إطارًا بإطار (Rotoscoping) - يكفي إدخال أوامر نصية بسيطة، وستفهم النموذج محتوى الفيديو، وتزيل الأشياء بدقة، أو تستبدل الخلفية، أو تغير لون عناصر معينة، مع الحفاظ التام على مسار الحركة الأصلي وعلاقات الإضاءة في الفيديو.',
        feature2Title: 'التحكم في الاتساق بين الإطار الأولي والنهائي (Start & End Frame Control)',
        feature2Description: 'يسمح للمستخدم بتحميل صورة أولية وصورة نهائية في نفس الوقت - سيقوم Kling O1 تلقائيًا بإنشاء حركة انتقالية طبيعية وسلسة بين هذين الإطارين. هذا أمر بالغ الأهمية لإنشاء تحولات سلسة بين المشاهد، أو تشوه للأشياء، أو ربط لقطتين مختلفتين، مما يرفع بشكل كبير الاتساق السردي.',
        feature3Title: 'التوليد مع الاتساق في الأجسام المتعددة (Multi-Subject Consistency)',
        feature3Description: 'يحل مشكلة "تغيير الشخصية عند تغيير اللقطة" في الفيديوهات الاصطناعية. يمتلك Kling O1 قدرة تشبه "ذاكرة المخرج"، حيث يمكنه فهم وتذكر خصائص الشخصيات أو الأشياء التي يقوم المستخدم بتحميلها (مثل الملامح facial، الملابس، الأدوات)، مع الحفاظ على مظهر متسق للغاية في لقطات وحركات الكاميرا المختلفة، وهو مثالي لإنشاء مسلسلات قصيرة مستمرة أو إعلانات.',
        feature4Title: 'نقل وإعادة رسم أسلوب الفيديو (Video Style Repainting)',
        feature4Description: 'مع الحفاظ على هيكل الفيديو الأصلي وتكوينه وحركاته سليمة، يقوم بتصوير الفيديو بالكامل بأسلوب فني جديد من خلال تلميحات نصية. سواء كان تحويل فيديو مصور حديثًا إلى أنمي ثنائي الأبعاد، أو تغيير مشهد نهاري إلى ليلة سيبر بانك، يمكن تحقيق ذلك بنقرة واحدة.',
        feature5Title: 'إعادة إنتاج مسار الحركة (Motion Transfer)',
        feature5Description: 'يستخرج نمط الحركة من فيديو مرجعي (مثل طريقة حركة الكاميرا أو حركة الشخص)، ويطبقه على موضوع أو مشهد جديد تمامًا. هذا يعني أنه يمكنك استخدام فيديو بسيط مصور بالهاتف المحمول كمواد "لتلخيص الحركة"، لجعل شخصية عالية الجودة تم إنشاؤها بواسطة الذكاء الاصطناعي تقوم بالحركة نفسها تمامًا.',

        // 如何使用部分
        howToUseTitle: 'كيفية استخدام Kling O1 على WeryAI',
        step1Title: 'اختيار النموذج',
        step1Description: 'اختر نموذج Kling O1 في أداة الفيديو بالذكاء الاصطناعي.',
        step2Title: 'اختيار الوظيفة',
        step2Description: 'اختر توليد الإطار الأولي/النهائي أو التوليد متعدد الصور المرجعية.',
        step3Title: 'إدخال المحتوى',
        step3Description: 'قم بتحميل الصور المرجعية وأدخل التلميحات.',
        step4Title: 'توليد الفيديو',
        step4Description: 'انقر على زر التوليد، وانتظر وقم بتنزيل الفيديو الخاص بك.',

        // YouTube 视频部分
        youtubeTitle: 'مقاطع فيديو رائعة عن Kling O1',

        // X Posts 部分
        xPostsTitle: 'اكتشف المزيد من المناقشات حول Kling O1',

        // 探索其他模型部分
        exploreModelsTitle: 'استكشف نماذج الفيديو الأخرى على WeryAI',
        kling25Title: 'Kling 2.5 Turbo Pro',
        runwayTitle: 'Runway Gen-4.5',
        lumaTitle: 'Luma Dream Machine',

        // FAQ 部分
        faqTitle: 'الأسئلة الشائعة',

        // CTA 部分
        ctaTitle: 'جرب Kling O1 الآن',
        ctaDescription: 'ابدأ في إنشاء فيديوهات اصطناعية متعددة الأنماط الموحدة مجانًا على WeryAI',
        ctaButton: 'ابدأ في توليد الفيديو',
        ctaDisclaimer: 'لا يلزم بطاقة ائتمان، يمكن الاستخدام بمجرد التسجيل',

        // YouTube 视频标题
        youtubeVideo1Title: 'Kling O1 - العرض الرسمي',
        youtubeVideo2Title: 'Kling O1 - نظرة عامة على الميزات',
        youtubeVideo3Title: 'Kling O1 - الدليل التعليمي',
        youtubeVideo4Title: 'Kling O1 - النصائح المتقدمة',
        youtubeVideo5Title: 'Kling O1 - سير العمل الإبداعي',
        youtubeVideo6Title: 'Kling O1 - أفضل الممارسات',

        // Alt 文本
        logoAlt: 'Kling',

        // Structured Data
        structuredDataName: 'مولد الفيديو الاصطناعي Kling O1',
        structuredDataDescription: 'Kling O1 هو أول نموذج فيديو متعدد الأنماط الموحد في السوق، يدعم التحرير من الفيديو باللغة الطبيعية، التحكم في الإطار الأولي والنهائي، والاتساق في الأجسام المتعددة',
        structuredDataFeature1: 'تحرير الفيديو باللغة الطبيعية',
        structuredDataFeature2: 'التحكم في الإطار الأولي والنهائي',
        structuredDataFeature3: 'الاتساق في الأجسام المتعددة',
        structuredDataFeature4: 'إعادة رسم أسلوب الفيديو',
        structuredDataFeature5: 'إعادة إنتاج مسار الحركة',
        },
    th: { // Thai (copied from English)
        // SEO Meta
        pageTitle: 'Kling O1 AI Video Generator - Unified Multimodal Video Model, Natural Language Editing, Character Consistency',
        pageDescription: 'Experience Kuaishou Kling AI\'s latest masterpiece Kling O1, the industry\'s first unified multimodal video model supporting natural language video editing, start & end frame control, and multi-subject consistency. Try now on WeryAI.',
        pageKeywords: 'Kling O1, unified multimodal, video editing, character consistency, AI video generator, natural language editing, WeryAI',

        // Generator section
        generatorTitle: 'Kling O1 Video Generator',
        generatorDescription: 'ขณะนี้ WeryAI ได้ผสานรวมโมเดล Kling O1 อย่างลึกซึ้งแล้ว ขณะนี้ WeryAI ได้ผสานรวมโมเดล Kling O1 อย่างลึกซึ้งแล้ว Kling O1 is the industry\'s first unified multimodal video model launched by Kuaishou Kling AI in December 2025. Unlike traditional text-to-video models, Kling O1 adopts a revolutionary MVL (Multimodal Visual Language) architecture, breaking the boundaries between video generation and editing, allowing users to directly modify elements, lighting, or actions in existing videos through natural language conversation, without complex masks or post-production software. It not only generates high-quality videos but also solves the two major pain points of AI video: "character consistency" and "precise editing". Experience Kling O1 on WeryAI for free and redefine your video post-production workflow with a single sentence!',

        // Tabs
        tabImageToVideo: 'Image to Video',
        tabTextToVideo: 'Text to Video',

        // Core features section
        coreFeaturesTitle: 'Kling O1 Core Features',

        // Features
        feature1Title: 'Natural Language Video Editing (Video Inpainting & Editing)',
        feature1Description: 'This is Kling O1\'s most revolutionary feature. You don\'t need to use professional video editing software for frame-by-frame rotoscoping. Simply input text instructions, and the model can understand video content, precisely remove objects, replace backgrounds, or change the color of specific elements while perfectly preserving the video\'s original motion trajectories and lighting relationships.',
        feature2Title: 'Start & End Frame Control',
        feature2Description: 'Allows users to upload both a start image and an end image, and Kling O1 will automatically generate natural, smooth transition animations between these two frames. This is crucial for creating seamless scene transitions, object morphing, or connecting two different shots, greatly enhancing narrative coherence.',
        feature3Title: 'Multi-Subject Consistency',
        feature3Description: 'Solves the problem of "characters changing between shots" in AI videos. Kling O1 has a "director\'s memory" capability, understanding and remembering character or object features (such as faces, clothing, props) uploaded by users, maintaining highly consistent appearance across different shots and camera movements. Perfect for creating continuous short dramas or advertisements.',
        feature4Title: 'Video Style Repainting',
        feature4Description: 'While keeping the original video\'s structure, composition, and motion completely unchanged, render the entire video into a new artistic style through text prompts. Whether converting live-action footage to anime, or changing daytime scenes to cyberpunk nightscapes, it can be done with one click.',
        feature5Title: 'Motion Transfer',
        feature5Description: 'Extract motion patterns (such as camera movements or character actions) from a reference video and apply them to entirely new subjects or scenes. This means you can use a simple phone recording as "motion capture" material and have AI-generated high-quality characters perform exactly the same movements.',

        // How to use section
        howToUseTitle: 'How to Use Kling O1 on WeryAI',
        step1Title: 'Select Model',
        step1Description: 'Select the Kling O1 model in the AI video tool.',
        step2Title: 'Select Function',
        step2Description: 'Choose Start/End Frame Generation or Multi-Image Reference Generation.',
        step3Title: 'Input Content',
        step3Description: 'Upload reference images and enter prompts.',
        step4Title: 'Generate Video',
        step4Description: 'Click the Generate button, wait, and download your video.',

        // YouTube videos section
        youtubeTitle: 'Exciting Video Introductions About Kling O1',

        // X Posts section
        xPostsTitle: 'Explore More Discussions About Kling O1',

        // Explore other models section
        exploreModelsTitle: 'Explore Other Video Models on WeryAI',
        kling25Title: 'Kling 2.5 Turbo Pro',
        runwayTitle: 'Runway Gen-4.5',
        lumaTitle: 'Luma Dream Machine',

        // FAQ section
        faqTitle: 'Frequently Asked Questions',

        // CTA section
        ctaTitle: 'Experience Kling O1 Now',
        ctaDescription: 'Start creating unified multimodal AI videos for free on WeryAI',
        ctaButton: 'Start Generating Videos',
        ctaDisclaimer: 'No credit card required, register to use',


        // YouTube video titles
        youtubeVideo1Title: 'Kling O1 - Official Demo',
        youtubeVideo2Title: 'Kling O1 - Features Overview',
        youtubeVideo3Title: 'Kling O1 - Tutorial',
        youtubeVideo4Title: 'Kling O1 - Advanced Techniques',
        youtubeVideo5Title: 'Kling O1 - Creative Workflow',
        youtubeVideo6Title: 'Kling O1 - Best Practices',

        // Alt text
        logoAlt: 'Kling',

        // Structured Data
        structuredDataName: 'Kling O1 AI Video Generator',
        structuredDataDescription: 'Kling O1 is the industry\'s first unified multimodal video model supporting natural language video editing, start & end frame control, and multi-subject consistency',
        structuredDataFeature1: 'Natural Language Video Editing',
        structuredDataFeature2: 'Start & End Frame Control',
        structuredDataFeature3: 'Multi-Subject Consistency',
        structuredDataFeature4: 'Video Style Repainting',
        structuredDataFeature5: 'Motion Transfer',
        },
    da: { // Danish (copied from English)
        // SEO Meta
        pageTitle: 'Kling O1 AI Video Generator - Unified Multimodal Video Model, Natural Language Editing, Character Consistency',
        pageDescription: 'Experience Kuaishou Kling AI\'s latest masterpiece Kling O1, the industry\'s first unified multimodal video model supporting natural language video editing, start & end frame control, and multi-subject consistency. Try now on WeryAI.',
        pageKeywords: 'Kling O1, unified multimodal, video editing, character consistency, AI video generator, natural language editing, WeryAI',

        // Generator section
        generatorTitle: 'Kling O1 Video Generator',
        generatorDescription: 'WeryAI har nu integreret modellen Kling O1 i dybden, Kling O1 is the industry\'s first unified multimodal video model launched by Kuaishou Kling AI in December 2025. Unlike traditional text-to-video models, Kling O1 adopts a revolutionary MVL (Multimodal Visual Language) architecture, breaking the boundaries between video generation and editing, allowing users to directly modify elements, lighting, or actions in existing videos through natural language conversation, without complex masks or post-production software. It not only generates high-quality videos but also solves the two major pain points of AI video: "character consistency" and "precise editing". Experience Kling O1 on WeryAI for free and redefine your video post-production workflow with a single sentence!',

        // Tabs
        tabImageToVideo: 'Image to Video',
        tabTextToVideo: 'Text to Video',

        // Core features section
        coreFeaturesTitle: 'Kling O1 Core Features',

        // Features
        feature1Title: 'Natural Language Video Editing (Video Inpainting & Editing)',
        feature1Description: 'This is Kling O1\'s most revolutionary feature. You don\'t need to use professional video editing software for frame-by-frame rotoscoping. Simply input text instructions, and the model can understand video content, precisely remove objects, replace backgrounds, or change the color of specific elements while perfectly preserving the video\'s original motion trajectories and lighting relationships.',
        feature2Title: 'Start & End Frame Control',
        feature2Description: 'Allows users to upload both a start image and an end image, and Kling O1 will automatically generate natural, smooth transition animations between these two frames. This is crucial for creating seamless scene transitions, object morphing, or connecting two different shots, greatly enhancing narrative coherence.',
        feature3Title: 'Multi-Subject Consistency',
        feature3Description: 'Solves the problem of "characters changing between shots" in AI videos. Kling O1 has a "director\'s memory" capability, understanding and remembering character or object features (such as faces, clothing, props) uploaded by users, maintaining highly consistent appearance across different shots and camera movements. Perfect for creating continuous short dramas or advertisements.',
        feature4Title: 'Video Style Repainting',
        feature4Description: 'While keeping the original video\'s structure, composition, and motion completely unchanged, render the entire video into a new artistic style through text prompts. Whether converting live-action footage to anime, or changing daytime scenes to cyberpunk nightscapes, it can be done with one click.',
        feature5Title: 'Motion Transfer',
        feature5Description: 'Extract motion patterns (such as camera movements or character actions) from a reference video and apply them to entirely new subjects or scenes. This means you can use a simple phone recording as "motion capture" material and have AI-generated high-quality characters perform exactly the same movements.',

        // How to use section
        howToUseTitle: 'How to Use Kling O1 on WeryAI',
        step1Title: 'Select Model',
        step1Description: 'Select the Kling O1 model in the AI video tool.',
        step2Title: 'Select Function',
        step2Description: 'Choose Start/End Frame Generation or Multi-Image Reference Generation.',
        step3Title: 'Input Content',
        step3Description: 'Upload reference images and enter prompts.',
        step4Title: 'Generate Video',
        step4Description: 'Click the Generate button, wait, and download your video.',

        // YouTube videos section
        youtubeTitle: 'Exciting Video Introductions About Kling O1',

        // X Posts section
        xPostsTitle: 'Explore More Discussions About Kling O1',

        // Explore other models section
        exploreModelsTitle: 'Explore Other Video Models on WeryAI',
        kling25Title: 'Kling 2.5 Turbo Pro',
        runwayTitle: 'Runway Gen-4.5',
        lumaTitle: 'Luma Dream Machine',

        // FAQ section
        faqTitle: 'Frequently Asked Questions',

        // CTA section
        ctaTitle: 'Experience Kling O1 Now',
        ctaDescription: 'Start creating unified multimodal AI videos for free on WeryAI',
        ctaButton: 'Start Generating Videos',
        ctaDisclaimer: 'No credit card required, register to use',


        // YouTube video titles
        youtubeVideo1Title: 'Kling O1 - Official Demo',
        youtubeVideo2Title: 'Kling O1 - Features Overview',
        youtubeVideo3Title: 'Kling O1 - Tutorial',
        youtubeVideo4Title: 'Kling O1 - Advanced Techniques',
        youtubeVideo5Title: 'Kling O1 - Creative Workflow',
        youtubeVideo6Title: 'Kling O1 - Best Practices',

        // Alt text
        logoAlt: 'Kling',

        // Structured Data
        structuredDataName: 'Kling O1 AI Video Generator',
        structuredDataDescription: 'Kling O1 is the industry\'s first unified multimodal video model supporting natural language video editing, start & end frame control, and multi-subject consistency',
        structuredDataFeature1: 'Natural Language Video Editing',
        structuredDataFeature2: 'Start & End Frame Control',
        structuredDataFeature3: 'Multi-Subject Consistency',
        structuredDataFeature4: 'Video Style Repainting',
        structuredDataFeature5: 'Motion Transfer',
        },
    no: { // Norwegian (copied from English)
        // SEO Meta
        pageTitle: 'Kling O1 AI Video Generator - Unified Multimodal Video Model, Natural Language Editing, Character Consistency',
        pageDescription: 'Experience Kuaishou Kling AI\'s latest masterpiece Kling O1, the industry\'s first unified multimodal video model supporting natural language video editing, start & end frame control, and multi-subject consistency. Try now on WeryAI.',
        pageKeywords: 'Kling O1, unified multimodal, video editing, character consistency, AI video generator, natural language editing, WeryAI',

        // Generator section
        generatorTitle: 'Kling O1 Video Generator',
        generatorDescription: 'WeryAI har nå integrert modellen Kling O1 i dybden, Kling O1 is the industry\'s first unified multimodal video model launched by Kuaishou Kling AI in December 2025. Unlike traditional text-to-video models, Kling O1 adopts a revolutionary MVL (Multimodal Visual Language) architecture, breaking the boundaries between video generation and editing, allowing users to directly modify elements, lighting, or actions in existing videos through natural language conversation, without complex masks or post-production software. It not only generates high-quality videos but also solves the two major pain points of AI video: "character consistency" and "precise editing". Experience Kling O1 on WeryAI for free and redefine your video post-production workflow with a single sentence!',

        // Tabs
        tabImageToVideo: 'Image to Video',
        tabTextToVideo: 'Text to Video',

        // Core features section
        coreFeaturesTitle: 'Kling O1 Core Features',

        // Features
        feature1Title: 'Natural Language Video Editing (Video Inpainting & Editing)',
        feature1Description: 'This is Kling O1\'s most revolutionary feature. You don\'t need to use professional video editing software for frame-by-frame rotoscoping. Simply input text instructions, and the model can understand video content, precisely remove objects, replace backgrounds, or change the color of specific elements while perfectly preserving the video\'s original motion trajectories and lighting relationships.',
        feature2Title: 'Start & End Frame Control',
        feature2Description: 'Allows users to upload both a start image and an end image, and Kling O1 will automatically generate natural, smooth transition animations between these two frames. This is crucial for creating seamless scene transitions, object morphing, or connecting two different shots, greatly enhancing narrative coherence.',
        feature3Title: 'Multi-Subject Consistency',
        feature3Description: 'Solves the problem of "characters changing between shots" in AI videos. Kling O1 has a "director\'s memory" capability, understanding and remembering character or object features (such as faces, clothing, props) uploaded by users, maintaining highly consistent appearance across different shots and camera movements. Perfect for creating continuous short dramas or advertisements.',
        feature4Title: 'Video Style Repainting',
        feature4Description: 'While keeping the original video\'s structure, composition, and motion completely unchanged, render the entire video into a new artistic style through text prompts. Whether converting live-action footage to anime, or changing daytime scenes to cyberpunk nightscapes, it can be done with one click.',
        feature5Title: 'Motion Transfer',
        feature5Description: 'Extract motion patterns (such as camera movements or character actions) from a reference video and apply them to entirely new subjects or scenes. This means you can use a simple phone recording as "motion capture" material and have AI-generated high-quality characters perform exactly the same movements.',

        // How to use section
        howToUseTitle: 'How to Use Kling O1 on WeryAI',
        step1Title: 'Select Model',
        step1Description: 'Select the Kling O1 model in the AI video tool.',
        step2Title: 'Select Function',
        step2Description: 'Choose Start/End Frame Generation or Multi-Image Reference Generation.',
        step3Title: 'Input Content',
        step3Description: 'Upload reference images and enter prompts.',
        step4Title: 'Generate Video',
        step4Description: 'Click the Generate button, wait, and download your video.',

        // YouTube videos section
        youtubeTitle: 'Exciting Video Introductions About Kling O1',

        // X Posts section
        xPostsTitle: 'Explore More Discussions About Kling O1',

        // Explore other models section
        exploreModelsTitle: 'Explore Other Video Models on WeryAI',
        kling25Title: 'Kling 2.5 Turbo Pro',
        runwayTitle: 'Runway Gen-4.5',
        lumaTitle: 'Luma Dream Machine',

        // FAQ section
        faqTitle: 'Frequently Asked Questions',

        // CTA section
        ctaTitle: 'Experience Kling O1 Now',
        ctaDescription: 'Start creating unified multimodal AI videos for free on WeryAI',
        ctaButton: 'Start Generating Videos',
        ctaDisclaimer: 'No credit card required, register to use',


        // YouTube video titles
        youtubeVideo1Title: 'Kling O1 - Official Demo',
        youtubeVideo2Title: 'Kling O1 - Features Overview',
        youtubeVideo3Title: 'Kling O1 - Tutorial',
        youtubeVideo4Title: 'Kling O1 - Advanced Techniques',
        youtubeVideo5Title: 'Kling O1 - Creative Workflow',
        youtubeVideo6Title: 'Kling O1 - Best Practices',

        // Alt text
        logoAlt: 'Kling',

        // Structured Data
        structuredDataName: 'Kling O1 AI Video Generator',
        structuredDataDescription: 'Kling O1 is the industry\'s first unified multimodal video model supporting natural language video editing, start & end frame control, and multi-subject consistency',
        structuredDataFeature1: 'Natural Language Video Editing',
        structuredDataFeature2: 'Start & End Frame Control',
        structuredDataFeature3: 'Multi-Subject Consistency',
        structuredDataFeature4: 'Video Style Repainting',
        structuredDataFeature5: 'Motion Transfer',
        },
    nl: { // Dutch (copied from English)
        // SEO Meta
        pageTitle: 'Kling O1 AI Video Generator - Unified Multimodal Video Model, Natural Language Editing, Character Consistency',
        pageDescription: 'Experience Kuaishou Kling AI\'s latest masterpiece Kling O1, the industry\'s first unified multimodal video model supporting natural language video editing, start & end frame control, and multi-subject consistency. Try now on WeryAI.',
        pageKeywords: 'Kling O1, unified multimodal, video editing, character consistency, AI video generator, natural language editing, WeryAI',

        // Generator section
        generatorTitle: 'Kling O1 Video Generator',
        generatorDescription: 'WeryAI heeft het model Kling O1 nu diep geïntegreerd, Kling O1 is the industry\'s first unified multimodal video model launched by Kuaishou Kling AI in December 2025. Unlike traditional text-to-video models, Kling O1 adopts a revolutionary MVL (Multimodal Visual Language) architecture, breaking the boundaries between video generation and editing, allowing users to directly modify elements, lighting, or actions in existing videos through natural language conversation, without complex masks or post-production software. It not only generates high-quality videos but also solves the two major pain points of AI video: "character consistency" and "precise editing". Experience Kling O1 on WeryAI for free and redefine your video post-production workflow with a single sentence!',

        // Tabs
        tabImageToVideo: 'Image to Video',
        tabTextToVideo: 'Text to Video',

        // Core features section
        coreFeaturesTitle: 'Kling O1 Core Features',

        // Features
        feature1Title: 'Natural Language Video Editing (Video Inpainting & Editing)',
        feature1Description: 'This is Kling O1\'s most revolutionary feature. You don\'t need to use professional video editing software for frame-by-frame rotoscoping. Simply input text instructions, and the model can understand video content, precisely remove objects, replace backgrounds, or change the color of specific elements while perfectly preserving the video\'s original motion trajectories and lighting relationships.',
        feature2Title: 'Start & End Frame Control',
        feature2Description: 'Allows users to upload both a start image and an end image, and Kling O1 will automatically generate natural, smooth transition animations between these two frames. This is crucial for creating seamless scene transitions, object morphing, or connecting two different shots, greatly enhancing narrative coherence.',
        feature3Title: 'Multi-Subject Consistency',
        feature3Description: 'Solves the problem of "characters changing between shots" in AI videos. Kling O1 has a "director\'s memory" capability, understanding and remembering character or object features (such as faces, clothing, props) uploaded by users, maintaining highly consistent appearance across different shots and camera movements. Perfect for creating continuous short dramas or advertisements.',
        feature4Title: 'Video Style Repainting',
        feature4Description: 'While keeping the original video\'s structure, composition, and motion completely unchanged, render the entire video into a new artistic style through text prompts. Whether converting live-action footage to anime, or changing daytime scenes to cyberpunk nightscapes, it can be done with one click.',
        feature5Title: 'Motion Transfer',
        feature5Description: 'Extract motion patterns (such as camera movements or character actions) from a reference video and apply them to entirely new subjects or scenes. This means you can use a simple phone recording as "motion capture" material and have AI-generated high-quality characters perform exactly the same movements.',

        // How to use section
        howToUseTitle: 'How to Use Kling O1 on WeryAI',
        step1Title: 'Select Model',
        step1Description: 'Select the Kling O1 model in the AI video tool.',
        step2Title: 'Select Function',
        step2Description: 'Choose Start/End Frame Generation or Multi-Image Reference Generation.',
        step3Title: 'Input Content',
        step3Description: 'Upload reference images and enter prompts.',
        step4Title: 'Generate Video',
        step4Description: 'Click the Generate button, wait, and download your video.',

        // YouTube videos section
        youtubeTitle: 'Exciting Video Introductions About Kling O1',

        // X Posts section
        xPostsTitle: 'Explore More Discussions About Kling O1',

        // Explore other models section
        exploreModelsTitle: 'Explore Other Video Models on WeryAI',
        kling25Title: 'Kling 2.5 Turbo Pro',
        runwayTitle: 'Runway Gen-4.5',
        lumaTitle: 'Luma Dream Machine',

        // FAQ section
        faqTitle: 'Frequently Asked Questions',

        // CTA section
        ctaTitle: 'Experience Kling O1 Now',
        ctaDescription: 'Start creating unified multimodal AI videos for free on WeryAI',
        ctaButton: 'Start Generating Videos',
        ctaDisclaimer: 'No credit card required, register to use',


        // YouTube video titles
        youtubeVideo1Title: 'Kling O1 - Official Demo',
        youtubeVideo2Title: 'Kling O1 - Features Overview',
        youtubeVideo3Title: 'Kling O1 - Tutorial',
        youtubeVideo4Title: 'Kling O1 - Advanced Techniques',
        youtubeVideo5Title: 'Kling O1 - Creative Workflow',
        youtubeVideo6Title: 'Kling O1 - Best Practices',

        // Alt text
        logoAlt: 'Kling',

        // Structured Data
        structuredDataName: 'Kling O1 AI Video Generator',
        structuredDataDescription: 'Kling O1 is the industry\'s first unified multimodal video model supporting natural language video editing, start & end frame control, and multi-subject consistency',
        structuredDataFeature1: 'Natural Language Video Editing',
        structuredDataFeature2: 'Start & End Frame Control',
        structuredDataFeature3: 'Multi-Subject Consistency',
        structuredDataFeature4: 'Video Style Repainting',
        structuredDataFeature5: 'Motion Transfer',
        },
    id: { // Indonesian (copied from English)
        // SEO Meta
        pageTitle: 'Kling O1 AI Video Generator - Unified Multimodal Video Model, Natural Language Editing, Character Consistency',
        pageDescription: 'Experience Kuaishou Kling AI\'s latest masterpiece Kling O1, the industry\'s first unified multimodal video model supporting natural language video editing, start & end frame control, and multi-subject consistency. Try now on WeryAI.',
        pageKeywords: 'Kling O1, unified multimodal, video editing, character consistency, AI video generator, natural language editing, WeryAI',

        // Generator section
        generatorTitle: 'Kling O1 Video Generator',
        generatorDescription: 'WeryAI kini telah mengintegrasikan model Kling O1 secara mendalam, Kling O1 is the industry\'s first unified multimodal video model launched by Kuaishou Kling AI in December 2025. Unlike traditional text-to-video models, Kling O1 adopts a revolutionary MVL (Multimodal Visual Language) architecture, breaking the boundaries between video generation and editing, allowing users to directly modify elements, lighting, or actions in existing videos through natural language conversation, without complex masks or post-production software. It not only generates high-quality videos but also solves the two major pain points of AI video: "character consistency" and "precise editing". Experience Kling O1 on WeryAI for free and redefine your video post-production workflow with a single sentence!',

        // Tabs
        tabImageToVideo: 'Image to Video',
        tabTextToVideo: 'Text to Video',

        // Core features section
        coreFeaturesTitle: 'Kling O1 Core Features',

        // Features
        feature1Title: 'Natural Language Video Editing (Video Inpainting & Editing)',
        feature1Description: 'This is Kling O1\'s most revolutionary feature. You don\'t need to use professional video editing software for frame-by-frame rotoscoping. Simply input text instructions, and the model can understand video content, precisely remove objects, replace backgrounds, or change the color of specific elements while perfectly preserving the video\'s original motion trajectories and lighting relationships.',
        feature2Title: 'Start & End Frame Control',
        feature2Description: 'Allows users to upload both a start image and an end image, and Kling O1 will automatically generate natural, smooth transition animations between these two frames. This is crucial for creating seamless scene transitions, object morphing, or connecting two different shots, greatly enhancing narrative coherence.',
        feature3Title: 'Multi-Subject Consistency',
        feature3Description: 'Solves the problem of "characters changing between shots" in AI videos. Kling O1 has a "director\'s memory" capability, understanding and remembering character or object features (such as faces, clothing, props) uploaded by users, maintaining highly consistent appearance across different shots and camera movements. Perfect for creating continuous short dramas or advertisements.',
        feature4Title: 'Video Style Repainting',
        feature4Description: 'While keeping the original video\'s structure, composition, and motion completely unchanged, render the entire video into a new artistic style through text prompts. Whether converting live-action footage to anime, or changing daytime scenes to cyberpunk nightscapes, it can be done with one click.',
        feature5Title: 'Motion Transfer',
        feature5Description: 'Extract motion patterns (such as camera movements or character actions) from a reference video and apply them to entirely new subjects or scenes. This means you can use a simple phone recording as "motion capture" material and have AI-generated high-quality characters perform exactly the same movements.',

        // How to use section
        howToUseTitle: 'How to Use Kling O1 on WeryAI',
        step1Title: 'Select Model',
        step1Description: 'Select the Kling O1 model in the AI video tool.',
        step2Title: 'Select Function',
        step2Description: 'Choose Start/End Frame Generation or Multi-Image Reference Generation.',
        step3Title: 'Input Content',
        step3Description: 'Upload reference images and enter prompts.',
        step4Title: 'Generate Video',
        step4Description: 'Click the Generate button, wait, and download your video.',

        // YouTube videos section
        youtubeTitle: 'Exciting Video Introductions About Kling O1',

        // X Posts section
        xPostsTitle: 'Explore More Discussions About Kling O1',

        // Explore other models section
        exploreModelsTitle: 'Explore Other Video Models on WeryAI',
        kling25Title: 'Kling 2.5 Turbo Pro',
        runwayTitle: 'Runway Gen-4.5',
        lumaTitle: 'Luma Dream Machine',

        // FAQ section
        faqTitle: 'Frequently Asked Questions',

        // CTA section
        ctaTitle: 'Experience Kling O1 Now',
        ctaDescription: 'Start creating unified multimodal AI videos for free on WeryAI',
        ctaButton: 'Start Generating Videos',
        ctaDisclaimer: 'No credit card required, register to use',


        // YouTube video titles
        youtubeVideo1Title: 'Kling O1 - Official Demo',
        youtubeVideo2Title: 'Kling O1 - Features Overview',
        youtubeVideo3Title: 'Kling O1 - Tutorial',
        youtubeVideo4Title: 'Kling O1 - Advanced Techniques',
        youtubeVideo5Title: 'Kling O1 - Creative Workflow',
        youtubeVideo6Title: 'Kling O1 - Best Practices',

        // Alt text
        logoAlt: 'Kling',

        // Structured Data
        structuredDataName: 'Kling O1 AI Video Generator',
        structuredDataDescription: 'Kling O1 is the industry\'s first unified multimodal video model supporting natural language video editing, start & end frame control, and multi-subject consistency',
        structuredDataFeature1: 'Natural Language Video Editing',
        structuredDataFeature2: 'Start & End Frame Control',
        structuredDataFeature3: 'Multi-Subject Consistency',
        structuredDataFeature4: 'Video Style Repainting',
        structuredDataFeature5: 'Motion Transfer',
        },
    tr: { // Turkish (copied from English)
        // SEO Meta
        pageTitle: 'Kling O1 AI Video Generator - Unified Multimodal Video Model, Natural Language Editing, Character Consistency',
        pageDescription: 'Experience Kuaishou Kling AI\'s latest masterpiece Kling O1, the industry\'s first unified multimodal video model supporting natural language video editing, start & end frame control, and multi-subject consistency. Try now on WeryAI.',
        pageKeywords: 'Kling O1, unified multimodal, video editing, character consistency, AI video generator, natural language editing, WeryAI',

        // Generator section
        generatorTitle: 'Kling O1 Video Generator',
        generatorDescription: 'WeryAI artık Kling O1 modelini derinlemesine entegre ediyor, Kling O1 is the industry\'s first unified multimodal video model launched by Kuaishou Kling AI in December 2025. Unlike traditional text-to-video models, Kling O1 adopts a revolutionary MVL (Multimodal Visual Language) architecture, breaking the boundaries between video generation and editing, allowing users to directly modify elements, lighting, or actions in existing videos through natural language conversation, without complex masks or post-production software. It not only generates high-quality videos but also solves the two major pain points of AI video: "character consistency" and "precise editing". Experience Kling O1 on WeryAI for free and redefine your video post-production workflow with a single sentence!',

        // Tabs
        tabImageToVideo: 'Image to Video',
        tabTextToVideo: 'Text to Video',

        // Core features section
        coreFeaturesTitle: 'Kling O1 Core Features',

        // Features
        feature1Title: 'Natural Language Video Editing (Video Inpainting & Editing)',
        feature1Description: 'This is Kling O1\'s most revolutionary feature. You don\'t need to use professional video editing software for frame-by-frame rotoscoping. Simply input text instructions, and the model can understand video content, precisely remove objects, replace backgrounds, or change the color of specific elements while perfectly preserving the video\'s original motion trajectories and lighting relationships.',
        feature2Title: 'Start & End Frame Control',
        feature2Description: 'Allows users to upload both a start image and an end image, and Kling O1 will automatically generate natural, smooth transition animations between these two frames. This is crucial for creating seamless scene transitions, object morphing, or connecting two different shots, greatly enhancing narrative coherence.',
        feature3Title: 'Multi-Subject Consistency',
        feature3Description: 'Solves the problem of "characters changing between shots" in AI videos. Kling O1 has a "director\'s memory" capability, understanding and remembering character or object features (such as faces, clothing, props) uploaded by users, maintaining highly consistent appearance across different shots and camera movements. Perfect for creating continuous short dramas or advertisements.',
        feature4Title: 'Video Style Repainting',
        feature4Description: 'While keeping the original video\'s structure, composition, and motion completely unchanged, render the entire video into a new artistic style through text prompts. Whether converting live-action footage to anime, or changing daytime scenes to cyberpunk nightscapes, it can be done with one click.',
        feature5Title: 'Motion Transfer',
        feature5Description: 'Extract motion patterns (such as camera movements or character actions) from a reference video and apply them to entirely new subjects or scenes. This means you can use a simple phone recording as "motion capture" material and have AI-generated high-quality characters perform exactly the same movements.',

        // How to use section
        howToUseTitle: 'How to Use Kling O1 on WeryAI',
        step1Title: 'Select Model',
        step1Description: 'Select the Kling O1 model in the AI video tool.',
        step2Title: 'Select Function',
        step2Description: 'Choose Start/End Frame Generation or Multi-Image Reference Generation.',
        step3Title: 'Input Content',
        step3Description: 'Upload reference images and enter prompts.',
        step4Title: 'Generate Video',
        step4Description: 'Click the Generate button, wait, and download your video.',

        // YouTube videos section
        youtubeTitle: 'Exciting Video Introductions About Kling O1',

        // X Posts section
        xPostsTitle: 'Explore More Discussions About Kling O1',

        // Explore other models section
        exploreModelsTitle: 'Explore Other Video Models on WeryAI',
        kling25Title: 'Kling 2.5 Turbo Pro',
        runwayTitle: 'Runway Gen-4.5',
        lumaTitle: 'Luma Dream Machine',

        // FAQ section
        faqTitle: 'Frequently Asked Questions',

        // CTA section
        ctaTitle: 'Experience Kling O1 Now',
        ctaDescription: 'Start creating unified multimodal AI videos for free on WeryAI',
        ctaButton: 'Start Generating Videos',
        ctaDisclaimer: 'No credit card required, register to use',


        // YouTube video titles
        youtubeVideo1Title: 'Kling O1 - Official Demo',
        youtubeVideo2Title: 'Kling O1 - Features Overview',
        youtubeVideo3Title: 'Kling O1 - Tutorial',
        youtubeVideo4Title: 'Kling O1 - Advanced Techniques',
        youtubeVideo5Title: 'Kling O1 - Creative Workflow',
        youtubeVideo6Title: 'Kling O1 - Best Practices',

        // Alt text
        logoAlt: 'Kling',

        // Structured Data
        structuredDataName: 'Kling O1 AI Video Generator',
        structuredDataDescription: 'Kling O1 is the industry\'s first unified multimodal video model supporting natural language video editing, start & end frame control, and multi-subject consistency',
        structuredDataFeature1: 'Natural Language Video Editing',
        structuredDataFeature2: 'Start & End Frame Control',
        structuredDataFeature3: 'Multi-Subject Consistency',
        structuredDataFeature4: 'Video Style Repainting',
        structuredDataFeature5: 'Motion Transfer',
    },
}
